import { clinicRevenueChannelOptions } from './clinicsRevenueChannel';
import common from './common';
import languages from './languages';
import { ccmOnboardingStatuses } from './patient_statuses';
import { usStatesWithNone } from './states';
import {
  clinicProviderServiceTypeOptions,
  clinicReferralTypes,
  clinicServiceDeliveryModel,
  clinicServiceDeliveryThresholds,
} from './clinicProviderServiceTypeOptions.js';

import type {
  IFilterConversation,
  ISortConversation,
} from 'infrastructure/interfaces';

export const genders = [
  { id: 'male', label: 'Male' },
  { id: 'female', label: 'Female' },
];

export const maritalStatuses = [
  { id: 'married', label: 'Married' },
  { id: 'widowed', label: 'Widowed' },
  { id: 'separated', label: 'Separated' },
  { id: 'divorced', label: 'Divorced' },
  { id: 'single', label: 'Single' },
];

export const insuranceProviders = [
  { value: 'Medicare', label: 'Medicare' },
  { value: 'Texas Medicaid', label: 'Texas Medicaid' },
  { value: 'Private Pay', label: 'Private Pay' },
  { value: 'Texas Medicaid HMO', label: 'Texas Medicaid HMO' },
  { value: 'California Medicaid', label: 'California Medicaid' },
  { value: 'Commercial', label: 'Commercial' },
];

export const assigneeOptions = [
  { value: '', label: 'All', title: 'All' },
  { value: 'free', label: 'Free To Assign' },
  { value: 'me', label: 'Assigned To Me', title: 'Assigned To Me' },
];

export const interactionStatusOptions = [
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
];

export const interactionStatusRpmOptions = [
  { value: 'true', label: 'True' },
  { value: 'true_by_practice', label: 'True/By Clinic' },
  { value: 'false', label: 'False' },
];

export const workingStatuses = [
  { id: 'permanent_employee', label: 'Permanent Employee' },
  { id: 'temporary_employee', label: 'Temporary Employee' },
  { id: 'self_employed', label: 'Self-Employed' },
  { id: 'retired', label: 'Retired' },
  { id: 'internship', label: 'Internship' },
  { id: 'freelance', label: 'Freelance' },
  { id: 'unemployed', label: 'Unemployed' },
];

export const races = [
  {
    id: 'american_indian_or_alaska_native',
    label: 'American Indian or Alaska Native',
  },
  { id: 'asian', label: 'Asian' },
  { id: 'black_or_african_american', label: 'Black or African American' },
  { id: 'hispanic_or_latino', label: 'Hispanic or Latino' },
  {
    id: 'native_hawaiian_or_other_pacific_islander',
    label: 'Native Hawaiian or Other Pacific Islander',
  },
  { id: 'white', label: 'White' },
  { id: 'dynamic', label: 'Dynamic' },
  { id: 'other', label: 'Other' },
];

export const insuranceTypes = [
  { value: 'MMP', label: 'MMP' },
  { value: 'MQMB', label: 'MQMB' },
  { value: 'SSI MEDICAID', label: 'SSI MEDICAID' },
];

export const TimeZones = [
  { id: 'Pacific/Niue', label: '(GMT-11:00) Niue' },
  { id: 'Pacific/Pago_Pago', label: '(GMT-11:00) Pago Pago' },
  { id: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii Time' },
  { id: 'Pacific/Rarotonga', label: '(GMT-10:00) Rarotonga' },
  { id: 'Pacific/Tahiti', label: '(GMT-10:00) Tahiti' },
  { id: 'Pacific/Marquesas', label: '(GMT-09:30) Marquesas' },
  { id: 'America/Anchorage', label: '(GMT-09:00) Alaska Time' },
  { id: 'Pacific/Gambier', label: '(GMT-09:00) Gambier' },
  { id: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time' },
  { id: 'America/Tijuana', label: '(GMT-08:00) Pacific Time - Tijuana' },
  { id: 'America/Vancouver', label: '(GMT-08:00) Pacific Time - Vancouver' },
  {
    id: 'America/Whitehorse',
    label: '(GMT-08:00) Pacific Time - Whitehorse',
  },
  { id: 'Pacific/Pitcairn', label: '(GMT-08:00) Pitcairn' },
  {
    id: 'America/Dawson_Creek',
    label: '(GMT-07:00) Mountain Time - Dawson Creek',
  },
  { id: 'America/Denver', label: '(GMT-07:00) Mountain Time' },
  { id: 'America/Edmonton', label: '(GMT-07:00) Mountain Time - Edmonton' },
  { id: 'America/Hermosillo', label: '(GMT-07:00) Mountain Time - Hermosillo' },
  {
    id: 'America/Mazatlan',
    label: '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan',
  },
  { id: 'America/Phoenix', label: '(GMT-07:00) Mountain Time - Arizona' },
  {
    id: 'America/Yellowknife',
    label: '(GMT-07:00) Mountain Time - Yellowknife',
  },
  { id: 'America/Belize', label: '(GMT-06:00) Belize' },
  { id: 'America/Chicago', label: '(GMT-06:00) Central Time' },
  { id: 'America/Costa_Rica', label: '(GMT-06:00) Costa Rica' },
  { id: 'America/El_Salvador', label: '(GMT-06:00) El Salvador' },
  { id: 'America/Guatemala', label: '(GMT-06:00) Guatemala' },
  { id: 'America/Managua', label: '(GMT-06:00) Managua' },
  {
    id: 'America/Mexico_City',
    label: '(GMT-06:00) Central Time - Mexico City',
  },
  { id: 'America/Regina', label: '(GMT-06:00) Central Time - Regina' },
  {
    id: 'America/Tegucigalpa',
    label: '(GMT-06:00) Central Time - Tegucigalpa',
  },
  { id: 'America/Winnipeg', label: '(GMT-06:00) Central Time - Winnipeg' },
  { id: 'Pacific/Galapagos', label: '(GMT-06:00) Galapagos' },
  { id: 'America/Bogota', label: '(GMT-05:00) Bogota' },
  { id: 'America/Cancun', label: '(GMT-05:00) America Cancun' },
  { id: 'America/Cayman', label: '(GMT-05:00) Cayman' },
  { id: 'America/Guayaquil', label: '(GMT-05:00) Guayaquil' },
  { id: 'America/Havana', label: '(GMT-05:00) Havana' },
  { id: 'America/Iqaluit', label: '(GMT-05:00) Eastern Time - Iqaluit' },
  { id: 'America/Jamaica', label: '(GMT-05:00) Jamaica' },
  { id: 'America/Lima', label: '(GMT-05:00) Lima' },
  { id: 'America/Nassau', label: '(GMT-05:00) Nassau' },
  { id: 'America/New_York', label: '(GMT-05:00) Eastern Time' },
  { id: 'America/Panama', label: '(GMT-05:00) Panama' },
  { id: 'America/Port-au-Prince', label: '(GMT-05:00) Port-au-Prince' },
  { id: 'America/Rio_Branco', label: '(GMT-05:00) Rio Branco' },
  { id: 'America/Toronto', label: '(GMT-05:00) Eastern Time - Toronto' },
  { id: 'Pacific/Easter', label: '(GMT-05:00) Easter Island' },
  { id: 'America/Caracas', label: '(GMT-04:30) Caracas' },
  { id: 'America/Asuncion', label: '(GMT-03:00) Asuncion' },
  { id: 'America/Barbados', label: '(GMT-04:00) Barbados' },
  { id: 'America/Boa_Vista', label: '(GMT-04:00) Boa Vista' },
  { id: 'America/Campo_Grande', label: '(GMT-03:00) Campo Grande' },
  { id: 'America/Cuiaba', label: '(GMT-03:00) Cuiaba' },
  { id: 'America/Curacao', label: '(GMT-04:00) Curacao' },
  { id: 'America/Grand_Turk', label: '(GMT-04:00) Grand Turk' },
  { id: 'America/Guyana', label: '(GMT-04:00) Guyana' },
  { id: 'America/Halifax', label: '(GMT-04:00) Atlantic Time - Halifax' },
  { id: 'America/La_Paz', label: '(GMT-04:00) La Paz' },
  { id: 'America/Manaus', label: '(GMT-04:00) Manaus' },
  { id: 'America/Martinique', label: '(GMT-04:00) Martinique' },
  { id: 'America/Port_of_Spain', label: '(GMT-04:00) Port of Spain' },
  { id: 'America/Porto_Velho', label: '(GMT-04:00) Porto Velho' },
  { id: 'America/Puerto_Rico', label: '(GMT-04:00) Puerto Rico' },
  { id: 'America/Santo_Domingo', label: '(GMT-04:00) Santo Domingo' },
  { id: 'America/Thule', label: '(GMT-04:00) Thule' },
  { id: 'Atlantic/Bermuda', label: '(GMT-04:00) Bermuda' },
  { id: 'Canada/Atlantic', label: '(GMT-04:00) Atlantic Standard Time' },
  {
    id: 'America/St_Johns',
    label: '(GMT-03:30) Newfoundland Time - St. Johns',
  },
  { id: 'America/Araguaina', label: '(GMT-03:00) Araguaina' },
  { id: 'America/Argentina/Buenos_Aires', label: '(GMT-03:00) Buenos Aires' },
  { id: 'America/Bahia', label: '(GMT-03:00) Salvador' },
  { id: 'America/Belem', label: '(GMT-03:00) Belem' },
  { id: 'America/Cayenne', label: '(GMT-03:00) Cayenne' },
  { id: 'America/Fortaleza', label: '(GMT-03:00) Fortaleza' },
  { id: 'America/Godthab', label: '(GMT-03:00) Godthab' },
  { id: 'America/Maceio', label: '(GMT-03:00) Maceio' },
  { id: 'America/Miquelon', label: '(GMT-03:00) Miquelon' },
  { id: 'America/Montevideo', label: '(GMT-03:00) Montevideo' },
  { id: 'America/Paramaribo', label: '(GMT-03:00) Paramaribo' },
  { id: 'America/Recife', label: '(GMT-03:00) Recife' },
  { id: 'America/Santiago', label: '(GMT-03:00) Santiago' },
  { id: 'America/Sao_Paulo', label: '(GMT-02:00) Sao Paulo' },
  { id: 'Antarctica/Palmer', label: '(GMT-03:00) Palmer' },
  { id: 'Antarctica/Rothera', label: '(GMT-03:00) Rothera' },
  { id: 'Atlantic/Stanley', label: '(GMT-03:00) Stanley' },
  { id: 'America/Noronha', label: '(GMT-02:00) Noronha' },
  { id: 'Atlantic/South_Georgia', label: '(GMT-02:00) South Georgia' },
  { id: 'America/Scoresbysund', label: '(GMT-01:00) Scoresbysund' },
  { id: 'Atlantic/Azores', label: '(GMT-01:00) Azores' },
  { id: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Cape Verde' },
  { id: 'Africa/Abidjan', label: '(GMT+00:00) Abidjan' },
  { id: 'Africa/Accra', label: '(GMT+00:00) Accra' },
  { id: 'Africa/Bissau', label: '(GMT+00:00) Bissau' },
  { id: 'Africa/Casablanca', label: '(GMT+00:00) Casablanca' },
  { id: 'Africa/El_Aaiun', label: '(GMT+00:00) El Aaiun' },
  { id: 'Africa/Monrovia', label: '(GMT+00:00) Monrovia' },
  { id: 'America/Danmarkshavn', label: '(GMT+00:00) Danmarkshavn' },
  { id: 'Atlantic/Canary', label: '(GMT+00:00) Canary Islands' },
  { id: 'Atlantic/Faroe', label: '(GMT+00:00) Faeroe' },
  { id: 'Atlantic/Reykjavik', label: '(GMT+00:00) Reykjavik' },
  { id: 'Etc/GMT', label: '(GMT+00:00) GMT (no daylight saving)' },
  { id: 'Europe/Dublin', label: '(GMT+00:00) Dublin' },
  { id: 'Europe/Lisbon', label: '(GMT+00:00) Lisbon' },
  { id: 'Europe/London', label: '(GMT+00:00) London' },
  { id: 'Africa/Algiers', label: '(GMT+01:00) Algiers' },
  { id: 'Africa/Ceuta', label: '(GMT+01:00) Ceuta' },
  { id: 'Africa/Lagos', label: '(GMT+01:00) Lagos' },
  { id: 'Africa/Ndjamena', label: '(GMT+01:00) Ndjamena' },
  { id: 'Africa/Tunis', label: '(GMT+01:00) Tunis' },
  { id: 'Africa/Windhoek', label: '(GMT+02:00) Windhoek' },
  { id: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdam' },
  { id: 'Europe/Andorra', label: '(GMT+01:00) Andorra' },
  {
    id: 'Europe/Belgrade',
    label: '(GMT+01:00) Central European Time - Belgrade',
  },
  { id: 'Europe/Berlin', label: '(GMT+01:00) Berlin' },
  { id: 'Europe/Brussels', label: '(GMT+01:00) Brussels' },
  { id: 'Europe/Budapest', label: '(GMT+01:00) Budapest' },
  { id: 'Europe/Copenhagen', label: '(GMT+01:00) Copenhagen' },
  { id: 'Europe/Gibraltar', label: '(GMT+01:00) Gibraltar' },
  { id: 'Europe/Luxembourg', label: '(GMT+01:00) Luxembourg' },
  { id: 'Europe/Madrid', label: '(GMT+01:00) Madrid' },
  { id: 'Europe/Malta', label: '(GMT+01:00) Malta' },
  { id: 'Europe/Monaco', label: '(GMT+01:00) Monaco' },
  { id: 'Europe/Oslo', label: '(GMT+01:00) Oslo' },
  { id: 'Europe/Paris', label: '(GMT+01:00) Paris' },
  { id: 'Europe/Prague', label: '(GMT+01:00) Central European Time - Prague' },
  { id: 'Europe/Rome', label: '(GMT+01:00) Rome' },
  { id: 'Europe/Stockholm', label: '(GMT+01:00) Stockholm' },
  { id: 'Europe/Tirane', label: '(GMT+01:00) Tirane' },
  { id: 'Europe/Vienna', label: '(GMT+01:00) Vienna' },
  { id: 'Europe/Warsaw', label: '(GMT+01:00) Warsaw' },
  { id: 'Europe/Zurich', label: '(GMT+01:00) Zurich' },
  { id: 'Africa/Cairo', label: '(GMT+02:00) Cairo' },
  { id: 'Africa/Johannesburg', label: '(GMT+02:00) Johannesburg' },
  { id: 'Africa/Maputo', label: '(GMT+02:00) Maputo' },
  { id: 'Africa/Tripoli', label: '(GMT+02:00) Tripoli' },
  { id: 'Asia/Amman', label: '(GMT+02:00) Amman' },
  { id: 'Asia/Beirut', label: '(GMT+02:00) Beirut' },
  { id: 'Asia/Damascus', label: '(GMT+02:00) Damascus' },
  { id: 'Asia/Gaza', label: '(GMT+02:00) Gaza' },
  { id: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalem' },
  { id: 'Asia/Nicosia', label: '(GMT+02:00) Nicosia' },
  { id: 'Europe/Athens', label: '(GMT+02:00) Athens' },
  { id: 'Europe/Bucharest', label: '(GMT+02:00) Bucharest' },
  { id: 'Europe/Chisinau', label: '(GMT+02:00) Chisinau' },
  { id: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki' },
  { id: 'Europe/Istanbul', label: '(GMT+02:00) Istanbul' },
  { id: 'Europe/Kaliningrad', label: '(GMT+02:00) Moscow-01 - Kaliningrad' },
  { id: 'Europe/Kiev', label: '(GMT+02:00) Kyiv' },
  { id: 'Europe/Riga', label: '(GMT+02:00) Riga' },
  { id: 'Europe/Sofia', label: '(GMT+02:00) Sofia' },
  { id: 'Europe/Tallinn', label: '(GMT+02:00) Tallinn' },
  { id: 'Europe/Vilnius', label: '(GMT+02:00) Vilnius' },
  { id: 'Africa/Khartoum', label: '(GMT+03:00) Khartoum' },
  { id: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi' },
  { id: 'Antarctica/Syowa', label: '(GMT+03:00) Syowa' },
  { id: 'Asia/Baghdad', label: '(GMT+03:00) Baghdad' },
  { id: 'Asia/Qatar', label: '(GMT+03:00) Qatar' },
  { id: 'Asia/Riyadh', label: '(GMT+03:00) Riyadh' },
  { id: 'Europe/Minsk', label: '(GMT+03:00) Minsk' },
  { id: 'Europe/Moscow', label: '(GMT+03:00) Moscow+00 - Moscow' },
  { id: 'Asia/Tehran', label: '(GMT+03:30) Tehran' },
  { id: 'Asia/Baku', label: '(GMT+04:00) Baku' },
  { id: 'Asia/Dubai', label: '(GMT+04:00) Dubai' },
  { id: 'Asia/Tbilisi', label: '(GMT+04:00) Tbilisi' },
  { id: 'Asia/Yerevan', label: '(GMT+04:00) Yerevan' },
  { id: 'Europe/Samara', label: '(GMT+04:00) Moscow+01 - Samara' },
  { id: 'Indian/Mahe', label: '(GMT+04:00) Mahe' },
  { id: 'Indian/Mauritius', label: '(GMT+04:00) Mauritius' },
  { id: 'Indian/Reunion', label: '(GMT+04:00) Reunion' },
  { id: 'Asia/Kabul', label: '(GMT+04:30) Kabul' },
  { id: 'Antarctica/Mawson', label: '(GMT+05:00) Mawson' },
  { id: 'Asia/Aqtau', label: '(GMT+05:00) Aqtau' },
  { id: 'Asia/Aqtobe', label: '(GMT+05:00) Aqtobe' },
  { id: 'Asia/Ashgabat', label: '(GMT+05:00) Ashgabat' },
  { id: 'Asia/Dushanbe', label: '(GMT+05:00) Dushanbe' },
  { id: 'Asia/Karachi', label: '(GMT+05:00) Karachi' },
  { id: 'Asia/Tashkent', label: '(GMT+05:00) Tashkent' },
  { id: 'Asia/Yekaterinburg', label: '(GMT+05:00) Moscow+02 - Yekaterinburg' },
  { id: 'Indian/Kerguelen', label: '(GMT+05:00) Kerguelen' },
  { id: 'Indian/Maldives', label: '(GMT+05:00) Maldives' },
  { id: 'Asia/Calcutta', label: '(GMT+05:30) India Standard Time' },
  { id: 'Asia/Colombo', label: '(GMT+05:30) Colombo' },
  { id: 'Asia/Katmandu', label: '(GMT+05:45) Katmandu' },
  { id: 'Antarctica/Vostok', label: '(GMT+06:00) Vostok' },
  { id: 'Asia/Almaty', label: '(GMT+06:00) Almaty' },
  { id: 'Asia/Bishkek', label: '(GMT+06:00) Bishkek' },
  { id: 'Asia/Dhaka', label: '(GMT+06:00) Dhaka' },
  { id: 'Asia/Omsk', label: '(GMT+06:00) Moscow+03 - Omsk, Novosibirsk' },
  { id: 'Asia/Thimphu', label: '(GMT+06:00) Thimphu' },
  { id: 'Indian/Chagos', label: '(GMT+06:00) Chagos' },
  { id: 'Asia/Rangoon', label: '(GMT+06:30) Rangoon' },
  { id: 'Indian/Cocos', label: '(GMT+06:30) Cocos' },
  { id: 'Antarctica/Davis', label: '(GMT+07:00) Davis' },
  { id: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok' },
  { id: 'Asia/Hovd', label: '(GMT+07:00) Hovd' },
  { id: 'Asia/Jakarta', label: '(GMT+07:00) Jakarta' },
  { id: 'Asia/Krasnoyarsk', label: '(GMT+07:00) Moscow+04 - Krasnoyarsk' },
  { id: 'Asia/Saigon', label: '(GMT+07:00) Hanoi' },
  { id: 'Asia/Ho_Chi_Minh', label: '(GMT+07:00) Ho Chi Minh' },
  { id: 'Indian/Christmas', label: '(GMT+07:00) Christmas' },
  { id: 'Antarctica/Casey', label: '(GMT+08:00) Casey' },
  { id: 'Asia/Brunei', label: '(GMT+08:00) Brunei' },
  { id: 'Asia/Choibalsan', label: '(GMT+08:00) Choibalsan' },
  { id: 'Asia/Hong_Kong', label: '(GMT+08:00) Hong Kong' },
  { id: 'Asia/Irkutsk', label: '(GMT+08:00) Moscow+05 - Irkutsk' },
  { id: 'Asia/Kuala_Lumpur', label: '(GMT+08:00) Kuala Lumpur' },
  { id: 'Asia/Macau', label: '(GMT+08:00) Macau' },
  { id: 'Asia/Makassar', label: '(GMT+08:00) Makassar' },
  { id: 'Asia/Manila', label: '(GMT+08:00) Manila' },
  { id: 'Asia/Shanghai', label: '(GMT+08:00) China Time - Beijing' },
  { id: 'Asia/Singapore', label: '(GMT+08:00) Singapore' },
  { id: 'Asia/Taipei', label: '(GMT+08:00) Taipei' },
  { id: 'Asia/Ulaanbaatar', label: '(GMT+08:00) Ulaanbaatar' },
  { id: 'Australia/Perth', label: '(GMT+08:00) Western Time - Perth' },
  { id: 'Asia/Pyongyang', label: '(GMT+08:30) Pyongyang' },
  { id: 'Asia/Dili', label: '(GMT+09:00) Dili' },
  { id: 'Asia/Jayapura', label: '(GMT+09:00) Jayapura' },
  { id: 'Asia/Seoul', label: '(GMT+09:00) Seoul' },
  { id: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo' },
  { id: 'Asia/Yakutsk', label: '(GMT+09:00) Moscow+06 - Yakutsk' },
  { id: 'Pacific/Palau', label: '(GMT+09:00) Palau' },
  { id: 'Australia/Adelaide', label: '(GMT+10:30) Central Time - Adelaide' },
  { id: 'Australia/Darwin', label: '(GMT+09:30) Central Time - Darwin' },
  { id: 'Antarctica/DumontDUrville', label: "(GMT+10:00) Dumont D'Urville" },
  { id: 'Asia/Magadan', label: '(GMT+10:00) Moscow+07 - Magadan' },
  {
    id: 'Asia/Vladivostok',
    label: '(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk',
  },
  { id: 'Australia/Brisbane', label: '(GMT+10:00) Eastern Time - Brisbane' },
  { id: 'Australia/Hobart', label: '(GMT+11:00) Eastern Time - Hobart' },
  {
    id: 'Australia/Sydney',
    label: '(GMT+11:00) Eastern Time - Melbourne, Sydney',
  },
  { id: 'Pacific/Chuuk', label: '(GMT+10:00) Truk' },
  { id: 'Pacific/Guam', label: '(GMT+10:00) Guam' },
  { id: 'Pacific/Port_Moresby', label: '(GMT+10:00) Port Moresby' },
  { id: 'Pacific/Efate', label: '(GMT+11:00) Efate' },
  { id: 'Pacific/Guadalcanal', label: '(GMT+11:00) Guadalcanal' },
  { id: 'Pacific/Kosrae', label: '(GMT+11:00) Kosrae' },
  { id: 'Pacific/Norfolk', label: '(GMT+11:00) Norfolk' },
  { id: 'Pacific/Noumea', label: '(GMT+11:00) Noumea' },
  { id: 'Pacific/Pohnpei', label: '(GMT+11:00) Ponape' },
  {
    id: 'Asia/Kamchatka',
    label: '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy',
  },
  { id: 'Pacific/Auckland', label: '(GMT+13:00) Auckland' },
  { id: 'Pacific/Fiji', label: '(GMT+13:00) Fiji' },
  { id: 'Pacific/Funafuti', label: '(GMT+12:00) Funafuti' },
  { id: 'Pacific/Kwajalein', label: '(GMT+12:00) Kwajalein' },
  { id: 'Pacific/Majuro', label: '(GMT+12:00) Majuro' },
  { id: 'Pacific/Nauru', label: '(GMT+12:00) Nauru' },
  { id: 'Pacific/Tarawa', label: '(GMT+12:00) Tarawa' },
  { id: 'Pacific/Wake', label: '(GMT+12:00) Wake' },
  { id: 'Pacific/Wallis', label: '(GMT+12:00) Wallis' },
  { id: 'Pacific/Apia', label: '(GMT+14:00) Apia' },
  { id: 'Pacific/Enderbury', label: '(GMT+13:00) Enderbury' },
  { id: 'Pacific/Fakaofo', label: '(GMT+13:00) Fakaofo' },
  { id: 'Pacific/Tongatapu', label: '(GMT+13:00) Tongatapu' },
  { id: 'Pacific/Kiritimati', label: '(GMT+14:00) Kiritimati' },
];

export const numberType = [
  { id: 'mobile', label: 'Mobile', value: 'mobile' },
  { id: 'landline', label: 'Landline', value: 'landline' },
  { id: 'fixedVoip', label: 'FixedVoip', value: 'fixedVoip' },
  { id: 'nonFixedVoip', label: 'NonFixedVoip', value: 'nonFixedVoip' },
  { id: 'personal', label: 'Personal', value: 'personal' },
  { id: 'tollFree', label: 'TollFree', value: 'tollFree' },
  { id: 'premium', label: 'Premium', value: 'premium' },
  { id: 'sharedCost', label: 'SharedCost', value: 'sharedCost' },
  { id: 'uan', label: 'Uan', value: 'uan' },
  { id: 'voicemail', label: 'Voicemail', value: 'voicemail' },
  { id: 'pager', label: 'Pager', value: 'pager' },
  { id: 'unknown', label: 'Unknown', value: 'unknown' },
];

export const completionAppointmentMethod = [
  {
    id: 'phone_or_video_conference',
    label: 'Phone/Video Conference',
    value: 'Phone/Video Conference',
  },
  { id: 'sms_or_email', label: 'SMS/Email', value: 'SMS/Email' },
];

export const nextAppointmentMethod = [
  {
    id: 'phone_or_video_conference',
    label: 'Phone/Video Conference',
    value: 'Phone/Video Conference',
  },
  { id: 'sms', label: 'SMS', value: 'SMS' },
  { id: 'email', label: 'Email', value: 'Email' },
];

export const rpmAndCcmClaimOptions = [
  { id: 'feeForService', label: 'Fee for Service' },
  { id: 'pmpm', label: 'PMPM' },
  { id: 'valueBased', label: 'Value Based' },
  { id: 'grant', label: 'Grant' },
  { id: 'notBillable', label: 'Not Billable' },
] as const;

export const conversationReadFilter: IFilterConversation[] = [
  {
    id: 'all',
    type: 'read',
    label: 'All',
    value: '',
  },
  { id: 'read', type: 'read', label: 'Read', value: 'true' },
  { id: 'unread', type: 'read', label: 'Unread', value: 'false' },
];
export const conversationClosedFilter: IFilterConversation[] = [
  {
    id: 'all',
    type: 'closed',
    label: 'All',
    value: '',
  },
  { id: 'open', type: 'closed', label: 'Open', value: 'false' },
  { id: 'closed', type: 'closed', label: 'Closed', value: 'true' },
];
export const conversationLastMessageDateFilter: ISortConversation[] = [
  {
    id: 'newest',
    type: 'lastMessageDate',
    label: 'From new to old',
    value: 'newest',
  },
  {
    id: 'oldest',
    type: 'lastMessageDate',
    label: 'From old to new',
    value: 'oldest',
  },
];

export default {
  timeFilterRanges: [
    { id: 'last7days', label: 'Last 7 days', days: 7 },
    { id: 'last14days', label: 'Last 14 days', days: 14 },
    { id: 'last24hours', label: 'Last 24 hours', days: 1 },
    { id: 'last4hours', label: 'Last 4 hours', days: 0 },
    { id: 'currentmonth', label: 'Current Month' },
    { id: 'previousmonth', label: 'Previous Month' },
    { id: 'twomonthspast', label: 'Two months past' },
    { id: 'threemonthspast', label: 'Three months past' },
  ],
  adminPanelPatientFilter: [
    { id: 'fullName', label: 'Full Name', placeholder: 'John Doe' },
    { id: 'email', label: 'Email', placeholder: 'patient@gmail.com' },
    { id: 'phone', label: 'Phone Number', placeholder: 'Phone Number' },
    { id: 'deviceId', label: 'Device ID', placeholder: 'Device ID' },
    { id: 'guid', label: 'Patient ID', placeholder: 'Patient ID' },
  ],
  adminPanelPracticeUserFilter: [
    { id: 'fullName', label: 'Full Name', placeholder: 'John Doe' },
    { id: 'email', label: 'Email', placeholder: 'user@gmail.com' },
  ] as const,
  patientFilterOptions: [
    { id: 'fullName', label: 'Full Name', placeholder: 'John Doe' },
    { id: 'firstName', label: 'First Name', placeholder: 'John' },
    { id: 'lastName', label: 'Last Name', placeholder: 'Doe' },
    {
      id: 'birthDate',
      label: 'Birth Date',
      placeholder: common.dateFormats.birthDate,
    },
    { id: 'phone', label: 'Phone', placeholder: 'Phone Number' },
    { id: 'email', label: 'Email', placeholder: 'patient@gmail.com' },
    {
      id: 'guid',
      label: 'Patient ID',
      placeholder: 'Patient unique ID',
    },
    {
      id: 'insuranceNumber',
      label: 'Insurance Number',
      placeholder: 'Patient Insurance Number',
    },
  ] as const,
  clinicFilterOptions: [
    {
      id: 'legalname',
      label: 'Legal Name',
      placeholder: 'Legal Name',
    },
  ],
  agencyFilterOptions: [
    {
      id: 'legalname',
      label: 'Legal Name',
      placeholder: 'Legal Name',
    },
  ],
  doctorFilterOptions: [
    {
      id: 'name',
      label: 'Name',
      placeholder: 'Name',
    },
  ],
  agencyDoctorFilterOptions: [
    { id: 'fullName', label: 'Full Name', placeholder: 'John Doe' },
    {
      id: 'legalname',
      label: 'Legal Name',
      placeholder: 'Legal Name',
    },
    { id: 'email', label: 'Email', placeholder: 'patient@gmail.com' },
  ],
  patientPracticeOptions: [
    {
      id: 'birthDate',
      label: 'Birth Date',
      placeholder: common.dateFormats.birthDate,
    },
  ],
  withReadingOptions: [
    {
      id: 'all',
      label: 'All',
      value: '',
    },
    { id: 'with_reading', label: 'With Readings', value: 'true' },
    { id: 'without_reading', label: 'Without Readings', value: 'false' },
  ],
  profileFields: [
    { id: 'firstName', type: 'text', label: 'First Name' },
    { id: 'lastName', type: 'text', label: 'Last Name' },
    { id: 'middleName', type: 'text', label: 'Middle Name' },
    { id: 'email', type: 'text', label: 'Email' },
    { id: 'phone', type: 'text', label: 'Primary Phone Number' },
    { id: 'address', type: 'text', label: 'Address' },
    { id: 'birthDate', type: 'text', label: 'Birth Date' },
    {
      id: 'martialStatus',
      type: 'select',
      label: 'Marital Status',
      options: [...maritalStatuses],
    },
    {
      id: 'workingStatus',
      type: 'select',
      label: 'Working Status',
      options: [...workingStatuses],
    },
    {
      id: 'race',
      type: 'select',
      label: 'Race',
      options: [...races],
    },
    {
      id: 'gender',
      type: 'select',
      label: 'Gender',
      options: [...genders],
    },
    {
      id: 'timezone',
      type: 'select',
      label: 'Time Zone',
      options: TimeZones,
    },
    {
      id: 'emergencyContactNumber',
      type: 'text',
      label: 'Emergency Contact Number',
    },
    { id: 'city', type: 'text', label: 'City' },
    {
      id: 'state',
      type: 'select',
      label: 'State',
      options: usStatesWithNone,
      disabled: false,
    },
    { id: 'zipPostalCode', type: 'text', label: 'Zip Code' },
    { id: 'homeNumber', type: 'text', label: 'Secondary Phone Number' },
    {
      id: 'primaryNumberType',
      type: 'select',
      label: 'Primary Phone Number Type',
      options: [...numberType],
    },
    {
      id: 'secondaryNumberType',
      type: 'select',
      label: 'Secondary Phone Number Type',
      options: [...numberType],
    },
    {
      id: 'emergencyContactNumberType',
      type: 'select',
      label: 'Emergency Number Type',
      options: [...numberType],
    },
  ],
  orderConsumableFields: [
    {
      id: 'device_section',
      type: 'select',
      label: 'Glucometer Consumables',
      options: [
        { id: 'none', label: '' },
        {
          id: 'CBLS_G427B',
          label: 'G427B Strips and Lancets: Telli Health Device',
        },
      ],
    },
    {
      id: 'charger',
      type: 'select',
      label: 'Charger',
      options: [
        { id: 'none', label: '' },
        { id: 'USB-WC', label: 'USB-WC: USB Wall Charger' },
        { id: 'U807-PWR', label: 'U807-PWR: Telli Health BP Power Adapter' },
        { id: 'A600N-PWR', label: 'A600N-PWR: Telli Health BP Power Adapter' },
        {
          id: '4GTherm-PWR',
          label: '4GTherm-PWR: Telli Health BP Power Adapter',
        },
        {
          id: 'TSB8057-PWR',
          label: 'TSB8057-PWR: Telli Health BP Power Adapter',
        },
        {
          id: 'G427B-PWR',
          label: 'G427B-PWR: Telli Health BG Power Adapter',
        },
        {
          id: 'BP01-PWR',
          label: 'BP01-PWR: Telli Health BP Power Adapter',
        },
      ],
    },
    {
      id: 'blood_pressure',
      type: 'select',
      label: 'Blood Pressure',
      options: [
        { id: 'none', label: '' },
        {
          id: 'CUFF_SMALL_U807',
          label: 'CUFF_SMALL_U807: Bloodpressure Cuff, Small',
        },
        {
          id: 'CUFF_ADULT_U807',
          label: 'CUFF_ADULT_U807: Bloodpressure Cuff, Adult',
        },
        {
          id: 'CUFF_XL_U807',
          label: 'CUFF_XL_U807: Bloodpressure Cuff, Adult',
        },
        {
          id: 'CUFF_SMALL_A600N',
          label: 'CUFF_SMALL_A600N: Bloodpressure Cuff, Small',
        },
        {
          id: 'CUFF_ADULT_A600N',
          label: 'CUFF_ADULT_A600N: Bloodpressure Cuff, Adult',
        },
        {
          id: 'CUFF_XL_A600N',
          label: 'CUFF_XL_A600N: Bloodpressure Cuff, Adult',
        },
        {
          id: 'CUFF_SMALL_BP01',
          label: 'CUFF_SMALL_BP01: Bloodpressure Cuff, Small',
        },
        {
          id: 'CUFF_ADULT_BP01',
          label: 'CUFF_ADULT_BP01: Bloodpressure Cuff, Adult',
        },
        {
          id: 'CUFF_XL_BP01',
          label: 'CUFF_XL_BP01: Bloodpressure Cuff, Adult',
        },
      ],
    },
    {
      id: 'batteries',
      type: 'select',
      label: 'Batteries',
      options: [
        { id: 'none', label: '' },
        { id: 'aa', label: 'Batteries AA' },
        { id: 'aaa', label: 'Batteries AAA' },
      ],
    },
  ],
  sortSelect: [
    {
      label: 'Newest',
      value: false,
    },
    {
      label: 'Oldest',
      value: true,
    },
  ],
  medicationsFilterSelect: [
    { value: null, label: 'All' },
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' },
  ],
  clinicStatusFilterSelect: [
    { value: null, label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'delinquent', label: 'Delinquent' },
  ],
  loginStatusFilterSelect: [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'blocked', label: 'Blocked' },
  ],
  statusSelect: [
    { value: null, label: 'All' },
    { value: 'critical', label: 'Critical' },
    { value: 'risk', label: 'At-Risk' },
    { value: 'normal', label: 'Normal' },
  ],
  readingTypeSelect: [
    { value: null, label: 'All' },
    { value: 'BloodGlucose', label: 'Blood Glucose' },
    { value: 'BloodPressure', label: 'Blood Pressure' },
    { value: 'SpO2', label: 'SpO2' },
    { value: 'Temperature', label: 'Temperature' },
    { value: 'Weight', label: 'Weight' },
    { value: 'Pulse', label: 'Pulse' },
    { value: 'PeakFlow', label: 'Peak Flow' },
  ],
  assigneeSelect: [
    { value: null, label: 'All' },
    { value: 'me', label: 'Assigned To Me' },
    { value: 'free', label: 'Free To Assign' },
  ],
  activitiesType: [
    { value: false, label: 'Unaction' },
    { value: true, label: 'Actioned' },
  ],
  actionTimesQuotaSelect: [
    { value: null, label: 'All' },
    { value: 'over55', label: '55-60 mins' },
  ],
  patientDischargeStatuses: [
    {
      id: 'inactive_bad_no_signal_connectivity',
      label: 'Inactive Bad/No Signal Connectivity',
    },
    { id: 'inactive_changed_doctor', label: 'Inactive Changed Doctor' },
    {
      id: 'inactive_client_request_inconvenient',
      label: 'Inactive Client Request Inconvenient',
    },
    {
      id: 'inactive_client_request_moving',
      label: 'Inactive Client Request Moving',
    },
    {
      id: 'inactive_client_request_other',
      label: 'Inactive Client Request Other',
    },
    { id: 'inactive_expired', label: 'Inactive Expired' },
    {
      id: 'inactive_health_plan_request_goals_met',
      label: 'Inactive Health Plan Request Goals Met',
    },
    {
      id: 'inactive_health_plan_request_non_compliant',
      label: 'Inactive Health Plan Request Non Compliant',
    },
    {
      id: 'inactive_health_plan_request_other',
      label: 'Inactive Health Plan Request Other',
    },
    { id: 'inactive_hospice', label: 'Inactive Hospice' },
    { id: 'inactive_copay', label: 'Inactive Copay' },
    {
      id: 'inactive_long_term_care_rehab',
      label: 'Inactive Long Term Care/Rehab',
    },
    {
      id: 'inactive_loss_of_eligibility',
      label: 'Inactive Loss of Eligibility (Insurance)',
    },
    {
      id: 'inactive_physician_request',
      label: 'Inactive Physician Request',
    },
    {
      id: 'onboarding_unsuccessful',
      label: 'Onboarding Unsuccessful',
    },
  ],
  patientCcmDischargeStatuses: [
    {
      id: 'ccm_unenrolled_changed_doctor',
      label: 'CCM Unenrolled - Changed Doctor',
    },
    {
      id: 'ccm_unenrolled_client_request',
      label: 'CCM Unenrolled - Client Request',
    },
    {
      id: 'ccm_unenrolled_copay_loss_of_insurance',
      label: 'CCM Unenrolled - Copay/Loss of Insurance',
    },
    {
      id: 'ccm_unenrolled_non_adherent',
      label: 'CCM Unenrolled - Non-Adherent',
    },
    {
      id: 'ccm_unenrolled_expired',
      label: 'CCM Unenrolled - Expired',
    },
    {
      id: 'ccm_unenrolled_hospice',
      label: 'CCM Unenrolled - Hospice',
    },
    {
      id: 'ccm_unenrolled_long_term_skilled_nursing_facility_rehab',
      label: 'CCM Unenrolled - Long Term Skilled Nursing Facility/Rehab',
    },
    {
      id: 'ccm_unenrolled_physician_clinic_request',
      label: 'CCM Unenrolled - Physician/Clinic Request',
    },
    {
      id: 'ccm_unenrolled_client_request_moving',
      label: 'CCM Unenrolled - Client Request Moving',
    },
    {
      id: 'ccm_unenrolled_health_plan_request_goals_met',
      label: 'CCM Unenrolled - Health Plan Request Goals Met',
    },
    {
      id: 'ccm_unenrolled_other',
      label: 'CCM Unenrolled - Other',
    },
  ],
  patientCovidStatuses: [
    {
      id: 'covid_at_risk',
      label: 'Covid/At-riskCovid (2 days rule)',
    },
    {
      id: 'none',
      label: 'None (16 days rule)',
    },
  ],
  patientHoldingStatuses: [
    {
      id: 'vacation',
      label: 'Vacation',
    },
    {
      id: 'hospital',
      label: 'In Hospital',
    },
  ],
  ccmPatientStatuses: [
    { value: undefined, label: 'All' },
    {
      value: 'enrolled',
      label: 'Enrolled',
    },
    {
      value: 'ccm_calling_queue',
      label: 'CCM Calling Queue',
    },
    {
      value: 'ccm_patient_refused_copay_insurance',
      label: 'CCM Patient Refused - Co-pay/Insurance',
    },
    {
      value: 'ccm_patient_refused_expired',
      label: 'CCM Patient Refused - Expired',
    },
    {
      value: 'ccm_patient_refused_changed_doctor',
      label: 'CCM Patient Refused - Changed Doctor',
    },
    {
      value: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'CCM Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      value: 'ccm_patient_refused_wrong_contact_information',
      label: 'CCM Patient Refused - Wrong Contact Information',
    },
    {
      value: 'ccm_patient_refused_no_contact',
      label: 'CCM Patient Refused - No Contact',
    },
    {
      value: 'ccm_patient_refused_wants_to_discuss_with_physician',
      label: 'CCM Patient Refused - Wants to Discuss with Physician',
    },
    {
      value: 'ccm_patient_refused_other',
      label: 'CCM Patient Refused - Other',
    },
    {
      id: 'ccm_referral_on_hold',
      value: 'ccm_referral_on_hold',
      label: 'CCM Referral On-Hold',
    },
    {
      id: 'ccm_referral_received',
      value: 'ccm_referral_received',
      label: 'CCM Referral Received',
    },
    {
      id: 'ccm_referral_withdrawn',
      value: 'ccm_referral_withdrawn',
      label: 'CCM Referral Withdrawn',
    },
    {
      id: 'ccm_patient_no_contact',
      value: 'ccm_patient_no_contact',
      label: 'CCM Patient No Contact',
    },
    {
      value: 'ccm_onboarding',
      label: 'CCM Onboarding',
    },
    {
      value: 'ccm_onboarding_unsuccessful_no_contact',
      label: 'CCM Onboarding Unsuccessful - No Contact',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_refused',
      label: 'CCM Onboarding Unsuccessful - Patient Refused',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      label: 'CCM Onboarding Unsuccessful - Patient Not Qualified for CCM',
    },
    {
      value: 'ccm_onboarding_unsuccessful_changed_doctor',
      label: 'CCM Onboarding Unsuccessful - Changed Doctor',
    },
    {
      value: 'ccm_onboarding_unsuccessful_other',
      label: 'CCM Onboarding Unsuccessful - Other',
    },
    {
      value: 'ccm_unenrolled_changed_doctor',
      label: 'CCM Unenrolled - Changed Doctor',
    },
    {
      value: 'ccm_unenrolled_client_request',
      label: 'CCM Unenrolled - Client Request',
    },
    {
      value: 'ccm_unenrolled_copay_loss_of_insurance',
      label: 'CCM Unenrolled - Copay/Loss of Insurance',
    },
    {
      value: 'ccm_unenrolled_non_adherent',
      label: 'CCM Unenrolled - Non-Adherent',
    },
    {
      value: 'ccm_unenrolled_expired',
      label: 'CCM Unenrolled - Expired',
    },
    {
      value: 'ccm_unenrolled_hospice',
      label: 'CCM Unenrolled - Hospice',
    },
    {
      value: 'ccm_unenrolled_long_term_skilled_nursing_facility_rehab',
      label: 'CCM Unenrolled - Long Term Skilled Nursing Facility/Rehab',
    },
    {
      value: 'ccm_unenrolled_physician_clinic_request',
      label: 'CCM Unenrolled - Physician/Clinic Request',
    },
    {
      value: 'ccm_unenrolled_client_request_moving',
      label: 'CCM Unenrolled - Client Request Moving',
    },
    {
      value: 'ccm_unenrolled_health_plan_request_goals_met',
      label: 'CCM Unenrolled - Health Plan Request Goals Met',
    },
    {
      value: 'ccm_unenrolled_other',
      label: 'CCM Unenrolled - Other',
    },
    {
      value: 'not_enrolled',
      label: 'Not Enrolled',
    },
    {
      value: 'ccm_not_eligible_insurance_restrictions',
      label: 'CCM Not Eligible - Insurance Restrictions',
    },
    {
      value: 'ccm_not_eligible_missing_or_inaccurate_information',
      label: 'CCM Not Eligible - Missing or Inaccurate Information',
    },
  ],
  ccmPatientStatusesForPatientAcceptance: [
    { value: undefined, label: 'All' },
    {
      value: 'ccm_calling_queue',
      label: 'CCM Calling Queue',
    },
    {
      value: 'ccm_patient_refused_copay_insurance',
      label: 'CCM Patient Refused - Co-pay/Insurance',
    },
    {
      value: 'ccm_patient_refused_expired',
      label: 'CCM Patient Refused - Expired',
    },
    {
      value: 'ccm_patient_refused_changed_doctor',
      label: 'CCM Patient Refused - Changed Doctor',
    },
    {
      value: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'CCM Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      value: 'ccm_patient_refused_wrong_contact_information',
      label: 'CCM Patient Refused - Wrong Contact Information',
    },
    {
      value: 'ccm_patient_refused_no_contact',
      label: 'CCM Patient Refused - No Contact',
    },
    {
      value: 'ccm_patient_refused_wants_to_discuss_with_physician',
      label: 'CCM Patient Refused - Wants to Discuss with Physician',
    },
    {
      value: 'ccm_patient_refused_other',
      label: 'CCM Patient Refused - Other',
    },
    {
      value: 'ccm_onboarding',
      label: 'CCM Onboarding',
    },
    {
      value: 'ccm_onboarding_unsuccessful_no_contact',
      label: 'CCM Onboarding Unsuccessful - No Contact',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_refused',
      label: 'CCM Onboarding Unsuccessful - Patient Refused',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      label: 'CCM Onboarding Unsuccessful - Patient Not Qualified for CCM',
    },
    {
      value: 'ccm_onboarding_unsuccessful_changed_doctor',
      label: 'CCM Onboarding Unsuccessful - Changed Doctor',
    },
    {
      value: 'ccm_onboarding_unsuccessful_other',
      label: 'CCM Onboarding Unsuccessful - Other',
    },
    {
      value: 'not_enrolled',
      label: 'Not Enrolled',
    },
    {
      id: 'ccm_referral_on_hold',
      value: 'ccm_referral_on_hold',
      label: 'CCM Referral On-Hold',
    },
    {
      id: 'ccm_referral_received',
      value: 'ccm_referral_received',
      label: 'CCM Referral Received',
    },
    {
      id: 'ccm_referral_withdrawn',
      value: 'ccm_referral_withdrawn',
      label: 'CCM Referral Withdrawn',
    },
    {
      id: 'ccm_patient_no_contact',
      value: 'ccm_patient_no_contact',
      label: 'CCM Patient No Contact',
    },
  ],
  ccmInteractionStatuses: [
    { value: undefined, label: 'All' },
    { value: true, label: 'True' },
    { value: false, label: 'False' },
  ],
  ccmPatientActivities: [
    {
      id: 'patient-notes',
      label: 'Note',
    },
    {
      id: 'patient-message-response',
      label: 'SMS',
    },
    {
      id: 'patient-call',
      label: 'Call',
    },
    {
      id: 'patient-icd',
      label: 'ICD-10-Code',
    },
    {
      id: 'manual',
      label: 'Manual Time Log',
    },
  ],
  ccmHoldingStatuses: [
    { value: undefined, label: 'All' },
    { value: true, label: 'True' },
    { value: false, label: 'False' },
  ],
  patientOnboardingStatus: [
    { value: 'only_onboarding_flow', label: 'All' },
    { value: 'calling_queue', label: 'Calling Queue' },
    { value: 'patient_referral', label: 'Patient Referral' },
    { value: 'referral_on_hold', label: 'Referral On-Hold' },
    {
      value: 'patient_no_contact',
      label: 'Patient No Contact',
    },
    {
      id: 'patient_refused_connectivity_or_tech_barier',
      value: 'patient_refused_connectivity_or_tech_barier',
      label: 'Patient Refused - Connectivity/Tech Barier',
    },
    {
      id: 'patient_refused_copay_insurance',
      value: 'patient_refused_copay_insurance',
      label: 'Patient Refused - Co-pay/Insurance',
    },
    {
      id: 'patient_refused_not_interested_not_necessary_suspect_scam',
      value: 'patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      id: 'patient_refused_expired',
      value: 'patient_refused_expired',
      label: 'Patient Refused - Expired',
    },
    {
      id: 'patient_refused_there_is_no_one_to_help',
      value: 'patient_refused_there_is_no_one_to_help',
      label: 'Patient Refused - There is No one to Help',
    },
    {
      id: 'patient_refused_has_a_new_physician',
      value: 'patient_refused_has_a_new_physician',
      label: 'Patient Refused - Has a New Physician',
    },
    {
      id: 'patient_refused_wants_to_discuss_with_physician',
      value: 'patient_refused_wants_to_discuss_with_physician',
      label: 'Patient Refused - Wants to Discuss with Physician',
    },
    {
      id: 'patient_refused_wrong_contact_information',
      value: 'patient_refused_wrong_contact_information',
      label: 'Patient Refused - Wrong Contact Information',
    },
    {
      value: 'insurance_refused',
      label: 'Insurance Refused',
    },
    { value: 'onboarding', label: 'Onboarding' },
    { value: 'onboarding_unsuccessful', label: 'Onboarding Unsuccessful' },
  ],
  patientInactiveStatus: [
    {
      value: 'inactive_bad_no_signal_connectivity',
      label: 'Inactive Bad No Signal Connectivity',
    },
    { value: 'inactive_changed_doctor', label: 'Inactive Changed Doctor' },
    {
      value: 'inactive_client_request_inconvenient',
      label: 'Inactive Client Request Inconvenient',
    },
    {
      value: 'inactive_client_request_moving',
      label: 'Inactive Client Request Moving',
    },
    {
      value: 'inactive_client_request_other',
      label: 'Inactive Client Request Other',
    },
    { value: 'inactive_expired', label: 'Inactive Expired' },
    {
      value: 'inactive_health_plan_request_goals_met',
      label: 'Inactive Health Plan Request Goals Met',
    },
    {
      value: 'inactive_health_plan_request_non_compliant',
      label: 'Inactive Health Plan Request Non Compliant',
    },
    {
      value: 'inactive_health_plan_request_other',
      label: 'Inactive Health Plan Request Other',
    },
    { value: 'inactive_hospice', label: 'Inactive Hospice' },
    { value: 'inactive_copay', label: 'Inactive Copay' },
    {
      value: 'inactive_long_term_care_rehab',
      label: 'Inactive Long Term Care Rehab',
    },
    {
      value: 'inactive_loss_of_eligibility',
      label: 'Inactive Loss Of Eligibility',
    },
    {
      value: 'inactive_physician_request',
      label: 'Inactive Physician Request',
    },
  ],
  // Order:
  // 1.Active
  // 2.Onboarding statuses
  // 3.Inactive statuses
  // sorted by alphabet
  patientStatuses: [
    { id: 'active', value: 'active', label: 'Active' },
    {
      id: 'calling_queue',
      value: 'calling_queue',
      label: 'Calling Queue',
    },
    {
      id: 'insurance_refused',
      value: 'insurance_refused',
      label: 'Insurance Refused',
    },
    {
      id: 'onboarding',
      value: 'onboarding',
      label: 'Onboarding',
    },
    {
      id: 'onboarding_unsuccessful',
      value: 'onboarding_unsuccessful',
      label: 'Onboarding Unsuccessful',
    },
    {
      id: 'patient_no_contact',
      value: 'patient_no_contact',
      label: 'Patient No Contact',
    },
    {
      id: 'patient_referral',
      value: 'patient_referral',
      label: 'Patient Referral',
    },
    {
      id: 'referral_on_hold',
      value: 'referral_on_hold',
      label: 'Referral On-Hold',
    },
    {
      id: 'patient_refused_copay_insurance',
      value: 'patient_refused_copay_insurance',
      label: 'Patient Refused - Co-pay/Insurance',
    },
    {
      id: 'patient_refused_connectivity_or_tech_barier',
      value: 'patient_refused_connectivity_or_tech_barier',
      label: 'Patient Refused - Connectivity/Tech Barier',
    },
    {
      id: 'patient_refused_expired',
      value: 'patient_refused_expired',
      label: 'Patient Refused - Expired',
    },
    {
      id: 'patient_refused_has_a_new_physician',
      value: 'patient_refused_has_a_new_physician',
      label: 'Patient Refused - Has a New Physician',
    },
    {
      id: 'patient_refused_not_interested_not_necessary_suspect_scam',
      value: 'patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      id: 'patient_refused_there_is_no_one_to_help',
      value: 'patient_refused_there_is_no_one_to_help',
      label: 'Patient Refused - There is No one to Help',
    },
    {
      id: 'patient_refused_wants_to_discuss_with_physician',
      value: 'patient_refused_wants_to_discuss_with_physician',
      label: 'Patient Refused - Wants to Discuss with Physician',
    },
    {
      id: 'patient_refused_wrong_contact_information',
      value: 'patient_refused_wrong_contact_information',
      label: 'Patient Refused - Wrong Contact Information',
    },
    {
      id: 'pending_review',
      value: 'pending_review',
      label: 'Pending Review',
    },
    {
      id: 'referral_withdrawn',
      value: 'referral_withdrawn',
      label: 'Referral Withdrawn',
    },
    {
      id: 'inactive_bad_no_signal_connectivity',
      value: 'inactive_bad_no_signal_connectivity',
      label: 'Inactive Bad/No Signal Connectivity',
    },
    {
      id: 'inactive_changed_doctor',
      value: 'inactive_changed_doctor',
      label: 'Inactive Changed Doctor',
    },
    {
      id: 'inactive_client_request_inconvenient',
      value: 'inactive_client_request_inconvenient',
      label: 'Inactive Client Request Inconvenient',
    },
    {
      id: 'inactive_client_request_moving',
      value: 'inactive_client_request_moving',
      label: 'Inactive Client Request Moving',
    },
    {
      id: 'inactive_client_request_other',
      value: 'inactive_client_request_other',
      label: 'Inactive Client Request Other',
    },
    {
      id: 'inactive_copay',
      value: 'inactive_copay',
      label: 'Inactive Copay',
    },
    {
      id: 'inactive_expired',
      value: 'inactive_expired',
      label: 'Inactive Expired',
    },
    {
      id: 'inactive_health_plan_request_goals_met',
      value: 'inactive_health_plan_request_goals_met',
      label: 'Inactive Health Plan Request Goals Met',
    },
    {
      id: 'inactive_health_plan_request_non_compliant',
      value: 'inactive_health_plan_request_non_compliant',
      label: 'Inactive Health Plan Request Non Compliant',
    },
    {
      id: 'inactive_health_plan_request_other',
      value: 'inactive_health_plan_request_other',
      label: 'Inactive Health Plan Request Other',
    },
    {
      id: 'inactive_hospice',
      value: 'inactive_hospice',
      label: 'Inactive Hospice',
    },
    {
      id: 'inactive_long_term_care_rehab',
      value: 'inactive_long_term_care_rehab',
      label: 'Inactive Long Term Care/Rehab',
    },
    {
      id: 'inactive_loss_of_eligibility',
      value: 'inactive_loss_of_eligibility',
      label: 'Inactive Loss of Eligibility (Insurance)',
    },
    {
      id: 'inactive_physician_request',
      value: 'inactive_physician_request',
      label: 'Inactive Physician Request',
    },
    {
      id: 'not_eligible_insurance_restrictions',
      value: 'not_eligible_insurance_restrictions',
      label: 'Not Eligible - Insurance Restrictions',
    },
    {
      id: 'not_eligible_missing_or_inaccurate_information',
      value: 'not_eligible_missing_or_inaccurate_information',
      label: 'Not Eligible - Missing or Inaccurate Information',
    },
  ],
  // Order:
  // 1.Active
  // 2.Onboarding statuses
  // 3.Inactive statuses
  // sorted by alphabet
  ccmStatusOptions: [
    {
      id: 'enrolled',
      value: 'enrolled',
      label: 'Enrolled',
    },
    {
      id: 'ccm_calling_queue',
      value: 'ccm_calling_queue',
      label: 'CCM Calling Queue',
    },
    {
      id: 'ccm_patient_refused_copay_insurance',
      value: 'ccm_patient_refused_copay_insurance',
      label: 'CCM Patient Refused - Co-pay/Insurance',
    },
    {
      id: 'ccm_patient_refused_expired',
      value: 'ccm_patient_refused_expired',
      label: 'CCM Patient Refused - Expired',
    },
    {
      id: 'ccm_patient_refused_changed_doctor',
      value: 'ccm_patient_refused_changed_doctor',
      label: 'CCM Patient Refused - Changed Doctor',
    },
    {
      id: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      value: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'CCM Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      id: 'ccm_patient_refused_no_contact',
      value: 'ccm_patient_refused_no_contact',
      label: 'CCM Patient Refused - No Contact',
    },
    {
      id: 'ccm_patient_refused_wrong_contact_information',
      value: 'ccm_patient_refused_wrong_contact_information',
      label: 'CCM Patient Refused - Wrong Contact Information',
    },
    {
      id: 'ccm_patient_refused_wants_to_discuss_with_physician',
      value: 'ccm_patient_refused_wants_to_discuss_with_physician',
      label: 'CCM Patient Refused - Wants to Discuss with Physician',
    },
    {
      id: 'ccm_patient_refused_other',
      value: 'ccm_patient_refused_other',
      label: 'CCM Patient Refused - Other',
    },
    {
      id: 'ccm_referral_on_hold',
      value: 'ccm_referral_on_hold',
      label: 'CCM Referral On-Hold',
    },
    {
      id: 'ccm_referral_received',
      value: 'ccm_referral_received',
      label: 'CCM Referral Received',
    },
    {
      id: 'ccm_referral_withdrawn',
      value: 'ccm_referral_withdrawn',
      label: 'CCM Referral Withdrawn',
    },
    {
      id: 'ccm_patient_no_contact',
      value: 'ccm_patient_no_contact',
      label: 'CCM Patient No Contact',
    },
    {
      id: 'ccm_onboarding',
      value: 'ccm_onboarding',
      label: 'CCM Onboarding',
    },
    {
      id: 'ccm_onboarding_unsuccessful_no_contact',
      value: 'ccm_onboarding_unsuccessful_no_contact',
      label: 'CCM Onboarding Unsuccessful - No Contact',
    },
    {
      id: 'ccm_onboarding_unsuccessful_patient_refused',
      value: 'ccm_onboarding_unsuccessful_patient_refused',
      label: 'CCM Onboarding Unsuccessful - Patient Refused',
    },
    {
      id: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      value: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      label: 'CCM Onboarding Unsuccessful - Patient Not Qualified for CCM',
    },
    {
      id: 'ccm_onboarding_unsuccessful_changed_doctor',
      value: 'ccm_onboarding_unsuccessful_changed_doctor',
      label: 'CCM Onboarding Unsuccessful - Changed Doctor',
    },
    {
      id: 'ccm_onboarding_unsuccessful_other',
      value: 'ccm_onboarding_unsuccessful_other',
      label: 'CCM Onboarding Unsuccessful - Other',
    },
    {
      id: 'ccm_unenrolled_changed_doctor',
      value: 'ccm_unenrolled_changed_doctor',
      label: 'CCM Unenrolled - Changed Doctor',
    },
    {
      id: 'ccm_unenrolled_client_request',
      value: 'ccm_unenrolled_client_request',
      label: 'CCM Unenrolled - Client Request',
    },
    {
      id: 'ccm_unenrolled_copay_loss_of_insurance',
      value: 'ccm_unenrolled_copay_loss_of_insurance',
      label: 'CCM Unenrolled - Copay/Loss of Insurance',
    },
    {
      id: 'ccm_unenrolled_non_adherent',
      value: 'ccm_unenrolled_non_adherent',
      label: 'CCM Unenrolled - Non-Adherent',
    },
    {
      id: 'ccm_unenrolled_expired',
      value: 'ccm_unenrolled_expired',
      label: 'CCM Unenrolled - Expired',
    },
    {
      id: 'ccm_unenrolled_hospice',
      value: 'ccm_unenrolled_hospice',
      label: 'CCM Unenrolled - Hospice',
    },
    {
      id: 'ccm_unenrolled_long_term_skilled_nursing_facility_rehab',
      value: 'ccm_unenrolled_long_term_skilled_nursing_facility_rehab',
      label: 'CCM Unenrolled - Long Term Skilled Nursing Facility/Rehab',
    },
    {
      id: 'ccm_unenrolled_physician_clinic_request',
      value: 'ccm_unenrolled_physician_clinic_request',
      label: 'CCM Unenrolled - Physician/Clinic Request',
    },
    {
      id: 'ccm_unenrolled_client_request_moving',
      value: 'ccm_unenrolled_client_request_moving',
      label: 'CCM Unenrolled - Client Request Moving',
    },
    {
      id: 'ccm_unenrolled_health_plan_request_goals_met',
      value: 'ccm_unenrolled_health_plan_request_goals_met',
      label: 'CCM Unenrolled - Health Plan Request Goals Met',
    },
    {
      id: 'ccm_unenrolled_other',
      value: 'ccm_unenrolled_other',
      label: 'CCM Unenrolled - Other',
    },
    {
      id: 'not_enrolled',
      value: 'not_enrolled',
      label: 'Not Enrolled',
    },
    {
      id: 'ccm_not_eligible_insurance_restrictions',
      value: 'ccm_not_eligible_insurance_restrictions',
      label: 'CCM Not Eligible - Insurance Restrictions',
    },
    {
      id: 'ccm_not_eligible_missing_or_inaccurate_information',
      value: 'ccm_not_eligible_missing_or_inaccurate_information',
      label: 'CCM Not Eligible - Missing or Inaccurate Information',
    },
  ],
  ccmStatusOptionsForPatientAcceptanceRole: [
    {
      id: 'ccm_calling_queue',
      value: 'ccm_calling_queue',
      label: 'CCM Calling Queue',
    },
    {
      id: 'ccm_patient_refused_copay_insurance',
      value: 'ccm_patient_refused_copay_insurance',
      label: 'CCM Patient Refused - Co-pay/Insurance',
    },
    {
      id: 'ccm_patient_refused_expired',
      value: 'ccm_patient_refused_expired',
      label: 'CCM Patient Refused - Expired',
    },
    {
      id: 'ccm_patient_refused_changed_doctor',
      value: 'ccm_patient_refused_changed_doctor',
      label: 'CCM Patient Refused - Changed Doctor',
    },
    {
      id: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      value: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'CCM Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      id: 'ccm_patient_refused_wrong_contact_information',
      value: 'ccm_patient_refused_wrong_contact_information',
      label: 'CCM Patient Refused - Wrong Contact Information',
    },
    {
      id: 'ccm_patient_refused_wants_to_discuss_with_physician',
      value: 'ccm_patient_refused_wants_to_discuss_with_physician',
      label: 'CCM Patient Refused - Wants to Discuss with Physician',
    },
    {
      id: 'ccm_patient_refused_no_contact',
      value: 'ccm_patient_refused_no_contact',
      label: 'CCM Patient Refused - No Contact',
    },
    {
      id: 'ccm_patient_refused_other',
      value: 'ccm_patient_refused_other',
      label: 'CCM Patient Refused - Other',
    },
    {
      id: 'ccm_referral_on_hold',
      value: 'ccm_referral_on_hold',
      label: 'CCM Referral On-Hold',
    },
    {
      id: 'ccm_referral_received',
      value: 'ccm_referral_received',
      label: 'CCM Referral Received',
    },
    {
      id: 'ccm_referral_withdrawn',
      value: 'ccm_referral_withdrawn',
      label: 'CCM Referral Withdrawn',
    },
    {
      id: 'ccm_patient_no_contact',
      value: 'ccm_patient_no_contact',
      label: 'CCM Patient No Contact',
    },
    {
      id: 'ccm_onboarding',
      value: 'ccm_onboarding',
      label: 'CCM Onboarding',
    },
    {
      id: 'ccm_onboarding_unsuccessful_no_contact',
      value: 'ccm_onboarding_unsuccessful_no_contact',
      label: 'CCM Onboarding Unsuccessful - No Contact',
    },
    {
      id: 'ccm_onboarding_unsuccessful_patient_refused',
      value: 'ccm_onboarding_unsuccessful_patient_refused',
      label: 'CCM Onboarding Unsuccessful - Patient Refused',
    },
    {
      id: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      value: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      label: 'CCM Onboarding Unsuccessful - Patient Not Qualified for CCM',
    },
    {
      id: 'ccm_onboarding_unsuccessful_changed_doctor',
      value: 'ccm_onboarding_unsuccessful_changed_doctor',
      label: 'CCM Onboarding Unsuccessful - Changed Doctor',
    },
    {
      id: 'ccm_onboarding_unsuccessful_other',
      value: 'ccm_onboarding_unsuccessful_other',
      label: 'CCM Onboarding Unsuccessful - Other',
    },
    {
      id: 'not_enrolled',
      value: 'not_enrolled',
      label: 'Not Enrolled',
    },
  ],
  pcmStatuses: [
    { id: true, value: true, label: 'True' },
    { id: false, value: false, label: 'False' },
  ],
  selectServiceStatus: [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'no_service_plan', label: 'No Service Plan' },
    { value: 'expiring_soon', label: 'Expiring Soon' },
    { value: 'expired', label: 'Expired' },
  ],
  clinicInsuranceTypeSelect: [
    { value: null, label: 'All' },
    { value: 'Medicare', label: 'Medicare' },
    { value: 'Texas Medicaid', label: 'Texas Medicaid' },
    { value: 'Private Pay', label: 'Private Pay' },
    { value: 'Texas Medicaid HMO', label: 'Texas Medicaid HMO' },
    { value: 'Commercial', label: 'Commercial' },
    { value: 'California Medicaid', label: 'California Medicaid' },
  ],
  insuranceProviders: [...insuranceProviders],
  insuranceTypes: [...insuranceTypes],
  fulfillmentStage: [
    { value: 'all', label: 'All' },
    { value: 'patient_referral', label: 'Patient Referral' },
    { value: 'referral_on_hold', label: 'Referral On-Hold' },
    { value: 'referral_withdrawn', label: 'Referral Withdrawn' },
    { value: 'calling_queue', label: 'Calling Queue' },
    { value: 'patient_no_contact', label: 'Patient No Contact' },
    {
      value: 'patient_refused_connectivity_or_tech_barier',
      label: 'Patient Refused - Connectivity/Tech Barier',
    },
    {
      value: 'patient_refused_copay_insurance',
      label: 'Patient Refused - Co-pay/Insurance',
    },
    {
      value: 'patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    { value: 'patient_refused_expired', label: 'Patient Refused - Expired' },
    {
      value: 'patient_refused_there_is_no_one_to_help',
      label: 'Patient Refused - There is No one to Help',
    },
    {
      value: 'patient_refused_has_a_new_physician',
      label: 'Patient Refused - Has a New Physician',
    },
    {
      value: 'patient_refused_wants_to_discuss_with_physician',
      label: 'Patient Refused - Wants to Discuss with Physician',
    },
    {
      value: 'patient_refused_wrong_contact_information',
      label: 'Patient Refused - Wrong Contact Information',
    },
    { value: 'insurance_refused', label: 'Insurance Refused' },
    { value: 'onboarding', label: 'Onboarding' },
    { value: 'onboarding_unsuccessful', label: 'Onboarding Unsuccessful' },
  ],
  pcmStatusesFilter: [
    { id: null, value: null, label: 'All' },
    { id: 'true', value: 'true', label: 'True' },
    { id: 'false', value: 'false', label: 'False' },
  ],
  ccmFulfillmentStage: [
    {
      value: ccmOnboardingStatuses.join(','),
      label: 'All',
    },
    { value: 'ccm_referral_received', label: 'CCM Referral Received' },
    { value: 'ccm_referral_on_hold', label: 'CCM Referral On-Hold' },
    { value: 'ccm_referral_withdrawn', label: 'CCM Referral Withdrawn' },
    { value: 'ccm_patient_no_contact', label: 'CCM Patient No Contact' },
    {
      value: 'ccm_calling_queue',
      label: 'CCM Calling Queue',
    },
    {
      value: 'ccm_patient_refused_copay_insurance',
      label: 'CCM Patient Refused - Co-pay/Insurance',
    },
    {
      value: 'ccm_patient_refused_expired',
      label: 'CCM Patient Refused - Expired',
    },
    {
      value: 'ccm_patient_refused_changed_doctor',
      label: 'CCM Patient Refused - Changed Doctor',
    },
    {
      value: 'ccm_patient_refused_not_interested_not_necessary_suspect_scam',
      label: 'CCM Patient Refused - Not interested/Not necessary/Suspect Scam',
    },
    {
      value: 'ccm_patient_refused_no_contact',
      label: 'CCM Patient Refused - No Contact',
    },
    {
      value: 'ccm_patient_refused_wrong_contact_information',
      label: 'CCM Patient Refused - Wrong Contact Information',
    },
    {
      value: 'ccm_patient_refused_wants_to_discuss_with_physician',
      label: 'CCM Patient Refused - Wants to Discuss with Physician',
    },
    {
      value: 'ccm_patient_refused_other',
      label: 'CCM Patient Refused - Other',
    },
    {
      value: 'ccm_onboarding',
      label: 'CCM Onboarding',
    },
    {
      value: 'ccm_onboarding_unsuccessful_no_contact',
      label: 'CCM Onboarding Unsuccessful - No Contact',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_refused',
      label: 'CCM Onboarding Unsuccessful - Patient Refused',
    },
    {
      value: 'ccm_onboarding_unsuccessful_patient_not_qualified_for_ccm',
      label: 'CCM Onboarding Unsuccessful - Patient Not Qualified for CCM',
    },
    {
      value: 'ccm_onboarding_unsuccessful_changed_doctor',
      label: 'CCM Onboarding Unsuccessful - Changed Doctor',
    },
    {
      value: 'ccm_onboarding_unsuccessful_other',
      label: 'CCM Onboarding Unsuccessful - Other',
    },
    {
      value: 'ccm_not_eligible_insurance_restrictions',
      label: 'CCM Not Eligible - Insurance Restrictions',
    },
    {
      value: 'ccm_not_eligible_missing_or_inaccurate_information',
      label: 'CCM Not Eligible - Missing or Inaccurate Information',
    },
  ],
  thresholdsFields: [
    {
      id: 'criticalBloodoxygen',
      type: 'number',
      label: 'Critical',
    },
    {
      id: 'riskBloodoxygen',
      type: 'number',
      label: 'At Risk',
    },
    {
      id: 'maxCriticalSystolic',
      type: 'number',
      label: 'Max Critical',
    },
    {
      id: 'minCriticalSystolic',
      type: 'number',
      label: 'Min Critical',
    },
    {
      id: 'maxRiskSystolic',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minRiskSystolic',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'maxCriticalDiastolic',
      type: 'number',
      label: 'Max Critical',
    },
    {
      id: 'minCriticalDiastolic',
      type: 'number',
      label: 'Min Critical',
    },
    {
      id: 'maxRiskDiastolic',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minRiskDiastolic',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'maxCriticalPulse',
      type: 'number',
      label: 'Max Critical',
    },
    {
      id: 'minCriticalPulse',
      type: 'number',
      label: 'Min Critical',
    },
    {
      id: 'maxCriticalSleepPulse',
      type: 'number',
      label: 'Max Critical',
    },
    {
      id: 'minCriticalSleepPulse',
      type: 'number',
      label: 'Min Critical',
    },
    {
      id: 'maxRiskPulse',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minRiskPulse',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'maxRiskSleepPulse',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minRiskSleepPulse',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'riskBloodoxygen',
      type: 'number',
      label: 'At Risk',
    },
    {
      id: 'maxCriticalGlucose',
      type: 'number',
      label: 'Max Critical',
    },
    {
      id: 'minCriticalGlucose',
      type: 'number',
      label: 'Min Critical',
    },
    {
      id: 'maxRiskGlucose',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minRiskGlucose',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'baseLineWeight',
      type: 'number',
      label: 'Base Line',
    },
    {
      id: 'maxCriticalWeight',
      type: 'number',
      label: 'Max at Risk',
    },
    {
      id: 'minCriticalWeight',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'minRiskWeight',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'maxRiskWeight',
      type: 'number',
      label: 'Min at Risk',
    },
    {
      id: 'minCriticalFev1',
      type: 'number',
      label: 'Min Critical (L)',
    },
    {
      id: 'minCriticalPef',
      type: 'number',
      label: 'Min Critical (L/min)',
    },
    {
      id: 'minRiskPef',
      type: 'number',
      label: 'Min At Risk (L/min)',
    },
  ],
  careLocationsFields: [
    {
      id: 'facilityName',
      type: 'text',
      label: 'Name locations',
    },
    {
      id: 'facilityAddress',
      type: 'text',
      label: 'Address',
    },
    {
      id: 'city',
      type: 'text',
      label: 'City',
    },
    {
      id: 'state',
      type: 'select',
      label: 'State',
      options: usStatesWithNone,
      disabled: false,
    },
    {
      id: 'zipCode',
      type: 'text',
      label: 'Zip code',
    },
    {
      id: 'facilityNumber',
      type: 'text',
      label: 'Facility number',
    },
  ],
  titles: [
    { id: 'Mr.', label: 'Mr.' },
    { id: 'Mrs.', label: 'Mrs.' },
    { id: 'Ms.', label: 'Ms.' },
  ],
  preferredContactMethod: [
    { id: 'email', label: 'Email' },
    { id: 'phone', label: 'Phone' },
    { id: 'sms', label: 'Sms' },
  ],
  preferredLanguage: [...languages],
  readingTypes: [
    { value: 'BloodPressure', id: 'BloodPressure', label: 'Blood Pressure' },
    { value: 'BloodGlucose', id: 'BloodGlucose', label: 'Blood Glucose' },
    { value: 'Weight', id: 'Weight', label: 'Weight' },
    { value: 'SpO2', id: 'SpO2', label: 'SpO2' },
    { value: 'Temperature', id: 'Temperature', label: 'Temperature' },
    { value: 'SleepingMat', id: 'SleepingMat', label: 'Sleeping Mat' },
    { value: 'PeakFlow', id: 'PeakFlow', label: 'Peak Flow' },
  ],
  sleepingMatTypes: ['SleepingMatActivity', 'SleepingMatDuration'],
  userRoles: [
    { value: 'all', id: 'all', label: 'All' },
    { value: 'doctor', id: 'doctor', label: 'Doctor' },
    {
      value: 'md-physician',
      id: 'md-physician',
      label: 'Medical Doctor (MD)-Physician',
    },
    { value: 'physician', id: 'physician', label: 'Physician' },
    { value: 'pa', id: 'pa', label: 'Physician Assistant' },
    {
      value: 'pa-nurse',
      id: 'pa-nurse',
      label: 'Physician Assistant (PA)-Nurse',
    },
    { value: 'rn', id: 'rn', label: 'Registered Nurse' },
  ],
  adminPanelsUser: {
    userEdit: {
      personalInfo: [
        {
          id: 'title',
          type: 'select',
          label: 'Title',
          options: [
            { id: 'Mr.', label: 'Mr.' },
            { id: 'Mrs.', label: 'Mrs.' },
            { id: 'Ms.', label: 'Ms.' },
          ],
        },
        { id: 'firstName', type: 'text', label: 'First Name' },
        { id: 'middleName', type: 'text', label: 'Middle Name' },
        { id: 'lastName', type: 'text', label: 'Last Name' },
        { id: 'birthDate', type: 'text', label: 'Birth Date' },
        {
          id: 'race',
          type: 'select',
          label: 'Race',
          options: [...races],
        },
        {
          id: 'gender',
          type: 'select',
          label: 'Gender',
          options: [...genders],
        },
        {
          id: 'martialStatus',
          type: 'select',
          label: 'Marital Status',
          options: [...maritalStatuses],
        },
        {
          id: 'language',
          type: 'select',
          label: 'Preferred Language',
          options: [...languages],
        },
        {
          id: 'workingStatus',
          type: 'select',
          label: 'Working Status',
          options: [...workingStatuses],
        },
        { id: 'ethnicity', type: 'text', label: 'Ethnicity' },
        { id: 'auth0Enabled', type: 'text', label: 'Create Evelyn Account' },
      ],
      contactInfo: [
        { id: 'phone', type: 'text', label: 'Primary Phone Number' },
        {
          id: 'primaryNumberType',
          type: 'select',
          label: 'Primary Phone Number Type',
          options: [...numberType],
        },
        { id: 'address', type: 'text', label: 'Address' },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[0],
          options: TimeZones,
        },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'email', type: 'text', label: 'Email' },
        { id: 'city', type: 'text', label: 'City' },
        {
          id: 'preferredContactMethod',
          type: 'select',
          label: 'Preferred contact method',
          options: [
            { id: 'email', label: 'Email' },
            { id: 'phone', label: 'Phone' },
            { id: 'sms', label: 'Sms' },
          ],
        },
        { id: 'zipPostalCode', type: 'text', label: 'Zip code' },
        { id: 'emergencyContact', type: 'text', label: 'Emergency Contact' },
        {
          id: 'emergencyContactNumber',
          type: 'text',
          label: 'Emergency Contact Number',
        },
        {
          id: 'emergencyContactNumberType',
          type: 'select',
          label: 'Emergency Number Type',
          options: [...numberType],
        },
        {
          id: 'emergencyContactRelationship',
          type: 'text',
          label: 'Emergency Contact Relationship',
        },
        { id: 'homeNumber', type: 'text', label: 'Secondary Phone Number' },
        {
          id: 'secondaryNumberType',
          type: 'select',
          label: 'Secondary Phone Number Type',
          options: [...numberType],
        },
      ],
      dxcodes: [
        { id: 'bloodGlucose', type: 'text', label: 'Blood Glucose' },
        { id: 'bloodPressure', type: 'text', label: 'Blood Pressure' },
        { id: 'weight', type: 'text', label: 'Weight' },
        { id: 'pulmonary', type: 'text', label: 'Pulmonary' },
        { id: 'sleep', type: 'text', label: 'Sleep' },
        { id: 'allCodes', type: 'text', label: 'All Codes' },
      ],
      appointmentDetails: [
        {
          id: 'appointmentDate',
          type: 'date',
          label: 'Appointment Date',
          format: 'MMM dd yyyy',
        },
        {
          id: 'appointmentTime',
          type: 'time',
          label: 'Appointment Time (CST)',
          timeIntervals: 30,
        },
        {
          id: 'appointmentMethod',
          type: 'select',
          label: 'Appointment Method',
          options: [...nextAppointmentMethod],
        },
      ],
      doctorEmr: [
        { id: 'emrName', type: 'text', label: 'EMR Name' },
        { id: 'emrId1', type: 'text', label: 'EMR ID 1' },
        { id: 'emrId2', type: 'text', label: 'EMR ID 2' },
        {
          id: 'supervisingProviderId',
          type: 'text',
          label: 'Supervising Provider',
        },
        {
          id: 'renderingProviderId',
          type: 'text',
          label: 'Rendering Provider',
        },
      ],
      emr: [
        { id: 'account', type: 'text', label: 'Patient MRN ID' },
        { id: 'emrName', type: 'text', label: 'EMR Name' },
        { id: 'emrId1', type: 'text', label: 'EMR ID 1' },
        { id: 'emrId2', type: 'text', label: 'EMR ID 2' },
        {
          id: 'supervisingProviderId',
          type: 'text',
          label: 'Supervising Provider',
        },
        {
          id: 'renderingProviderId',
          type: 'text',
          label: 'Rendering Provider',
        },
      ],
      priorAuth: [
        {
          id: 'authorizationNumber',
          type: 'number',
          label: 'Authorization number',
        },
        { id: 'startDate', type: 'date', label: 'Start Date' },
        { id: 'endDate', type: 'date', label: 'End Date' },
      ],
      clinic: [
        { id: 'clinicAddress', label: 'Address', type: 'text' },
        { id: 'clinicState', label: 'State', type: 'text' },
        { id: 'clinicCity', label: 'City', type: 'text' },
      ],
      thresholds: {
        systolic: [
          { id: 'maxCriticalSystolic', label: 'Max Critical', type: 'text' },
          { id: 'minCriticalSystolic', label: 'Min Critical', type: 'text' },
          { id: 'maxRiskSystolic', label: 'Max at risk', type: 'text' },
          { id: 'minRiskSystolic', label: 'Min At Risk', type: 'text' },
        ],
        diastolic: [
          { id: 'maxCriticalDiastolic', label: 'Max Critical', type: 'text' },
          { id: 'minCriticalDiastolic', label: 'Min Critical', type: 'text' },
          { id: 'maxRiskDiastolic', label: 'Max at risk', type: 'text' },
          { id: 'minRiskDiastolic', label: 'Min At Risk', type: 'text' },
        ],
        pulse: [
          { id: 'maxCriticalPulse', label: 'Max Critical', type: 'text' },
          { id: 'minCriticalPulse', label: 'Min Critical', type: 'text' },
          { id: 'maxRiskPulse', label: 'Max at risk', type: 'text' },
          { id: 'minRiskPulse', label: 'Min At Risk', type: 'text' },
        ],
        sleepPulse: [
          { id: 'maxCriticalSleepPulse', label: 'Max Critical', type: 'text' },
          { id: 'minCriticalSleepPulse', label: 'Min Critical', type: 'text' },
          { id: 'maxRiskSleepPulse', label: 'Max at risk', type: 'text' },
          { id: 'minRiskSleepPulse', label: 'Min At Risk', type: 'text' },
        ],
        fev1: [
          { id: 'minCriticalFev1', label: 'Min Critical (L)', type: 'text' },
        ],
        pef: [
          { id: 'minCriticalPef', label: 'Min Critical (L/min)', type: 'text' },
          { id: 'minRiskPef', label: 'Min At Risk (L/min)', type: 'text' },
        ],
        glucose: [
          { id: 'maxCriticalGlucose', label: 'Max Critical', type: 'text' },
          { id: 'minCriticalGlucose', label: 'Min Critical', type: 'text' },
          { id: 'maxRiskGlucose', label: 'Max at risk', type: 'text' },
          { id: 'minRiskGlucose', label: 'Min At Risk', type: 'text' },
        ],
        sp02: [
          { id: 'criticalBloodoxygen', label: 'Min Critical', type: 'text' },
          { id: 'riskBloodoxygen', label: 'Min At risk', type: 'text' },
        ],
        weight: [
          { id: 'baseLineWeight', label: 'Baseline lbs', type: 'text' },
          { id: 'maxCriticalWeight', label: 'Critical +/-lbs', type: 'text' },
          { id: 'maxRiskWeight', label: 'At risk +/-lbs', type: 'text' },
        ],
      },
      careAgents: [
        {
          id: 'patManager',
          label: 'PAT Agent',
          type: 'select',
        },
        {
          id: 'onboardingManager',
          label: 'Onboarding Agent',
          type: 'select',
        },
        {
          id: 'ccmPatManager',
          label: 'CCM PAT Agent',
          type: 'select',
        },
        {
          id: 'ccmOnboardingAgent',
          label: 'CCM Onboarding Agent',
          type: 'select',
        },
        {
          id: 'ccmManager',
          label: 'CCM Case Manager',
          type: 'select',
        },
      ],
    },
    userAdd: {
      personalInfo: [
        {
          id: 'title',
          type: 'select',
          label: 'Title',
          options: [
            { id: 'Mr.', label: 'Mr.' },
            { id: 'Mrs.', label: 'Mrs.' },
            { id: 'Ms.', label: 'Ms.' },
          ],
        },
        { id: 'firstName', type: 'text', label: 'First Name' },
        { id: 'middleName', type: 'text', label: 'Middle Name' },
        { id: 'lastName', type: 'text', label: 'Last Name' },
        { id: 'birthDate', type: 'text', label: 'Birth Date' },
        { id: 'auth0Enabled', type: 'text', label: 'Create Evelyn Account' },
        { id: 'height', type: 'number', label: 'Height' },
        {
          id: 'weightGoal',
          type: 'number',
          label: 'Weight Goal',
          placeholder: 'lbs',
        },
        {
          id: 'takingReadingTime',
          type: 'time',
          label: 'Time for taking a reading',
        },
      ],
      contactInfo: [
        { id: 'phone', type: 'text', label: 'Mobile Number' },
        { id: 'workNumber', type: 'text', label: 'Work Number' },
        { id: 'email', type: 'text', label: 'Email' },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[0],
          options: TimeZones,
        },
      ],
      accountInfo: [
        {
          id: 'claimStatus',
          type: 'select',
          label: 'RPM Claim Status',
          defaultValue: rpmAndCcmClaimOptions[0],
          options: rpmAndCcmClaimOptions,
        },
        {
          id: 'ccmClaimStatus',
          type: 'select',
          label: 'CCM Claim Status',
          defaultValue: rpmAndCcmClaimOptions[0],
          options: rpmAndCcmClaimOptions,
        },
      ],
    },
  },
  adminPanelsDoctor: {
    userEdit: {
      personalInfo: [
        {
          id: 'title',
          type: 'select',
          label: 'Title',
          options: [
            { id: 'Mr.', label: 'Mr.' },
            { id: 'Mrs.', label: 'Mrs.' },
            { id: 'Ms.', label: 'Ms.' },
            { id: 'Dr.', label: 'Dr.' },
          ],
        },
        { id: 'firstName', type: 'text', label: 'First Name' },
        { id: 'middleName', type: 'text', label: 'Middle Name' },
        { id: 'lastName', type: 'text', label: 'Last Name' },
        { id: 'birthDate', type: 'date', label: 'Birth Date' },
        { id: 'mobileNumber', type: 'text', label: 'Mobile Number' },
        { id: 'workNumber', type: 'text', label: 'Work Number' },
        { id: 'email', type: 'text', label: 'User Email' },
        {
          id: 'primaryLanguage',
          type: 'select',
          label: 'Primary Language',
          options: [...languages],
        },
        {
          id: 'secondaryLanguage',
          type: 'select',
          label: 'Secondary Language',
          options: [...languages],
        },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[0],
          options: TimeZones,
        },
      ],
      address: [
        { id: 'addressLine1', type: 'text', label: 'User Address Line 1' },
        { id: 'city', type: 'text', label: 'City' },
        { id: 'addressLine2', type: 'text', label: 'User Address Line 2' },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip code' },
      ],
      registration: [
        { id: 'createdAt', type: 'text', label: 'Registered At' },
        { id: 'email', type: 'text', label: 'Username' },
      ],
    },
  },
  adminPanelAgencyDoctor: {
    userEdit: {
      personalInfo: [
        {
          id: 'title',
          type: 'select',
          label: 'Title',
          options: [
            { id: 'Mr.', label: 'Mr.' },
            { id: 'Mrs.', label: 'Mrs.' },
            { id: 'Ms.', label: 'Ms.' },
            { id: 'Dr.', label: 'Dr.' },
          ],
        },
        { id: 'firstName', type: 'text', label: 'First Name' },
        { id: 'middleName', type: 'text', label: 'Middle Name' },
        { id: 'lastName', type: 'text', label: 'Last Name' },
        { id: 'birthDate', type: 'date', label: 'Birth Date' },
        { id: 'mobileNumber', type: 'text', label: 'Mobile Number' },
        { id: 'workNumber', type: 'text', label: 'Work Number' },
        { id: 'email', type: 'text', label: 'User Email' },
        {
          id: 'primaryLanguage',
          type: 'select',
          label: 'Primary Language',
          options: [...languages],
        },
        {
          id: 'secondaryLanguage',
          type: 'select',
          label: 'Secondary Language',
          options: [...languages],
        },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[0],
          options: TimeZones,
        },
      ],
      address: [
        { id: 'addressLine1', type: 'text', label: 'User Address Line 1' },
        { id: 'city', type: 'text', label: 'City' },
        { id: 'addressLine2', type: 'text', label: 'User Address Line 2' },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip code' },
      ],
      registration: [
        { id: 'createdAt', type: 'text', label: 'Registered At' },
        { id: 'email', type: 'text', label: 'Username' },
      ],
    },
  },
  adminTurkUser: {
    userEdit: {
      personalInfo: [
        {
          id: 'title',
          type: 'select',
          label: 'Title',
          options: [
            { id: 'Mr.', label: 'Mr.' },
            { id: 'Mrs.', label: 'Mrs.' },
            { id: 'Ms.', label: 'Ms.' },
            { id: 'Dr.', label: 'Dr.' },
          ],
        },
        { id: 'firstName', type: 'text', label: 'First Name' },
        { id: 'middleName', type: 'text', label: 'Middle Name' },
        { id: 'lastName', type: 'text', label: 'Last Name' },
        { id: 'email', type: 'text', label: 'User Email' },
        {
          id: 'primaryLanguage',
          type: 'select',
          label: 'Primary Language',
          options: [...languages],
        },
        {
          id: 'secondaryLanguage',
          type: 'select',
          label: 'Secondary Language',
          options: [...languages],
        },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[0],
          options: TimeZones,
        },
      ],
      registration: [
        { id: 'createdAt', type: 'text', label: 'Registered At' },
        { id: 'email', type: 'text', label: 'Username' },
      ],
    },
  },
  adminPanelsClinic: {
    clinicEdit: {
      contact: [
        { id: 'legalname', type: 'text', label: 'Legal Name', disabled: false },
        { id: 'email', type: 'text', label: 'Business Email', disabled: false },
        { id: 'phone', type: 'text', label: 'Business Phone', disabled: false },
        { id: 'fax', type: 'text', label: 'Business Fax', disabled: false },
        {
          id: 'callerId',
          type: 'text',
          label: 'Clinic CallerID',
          disabled: false,
        },
        { id: 'crmId', type: 'text', label: 'CRM ID', disabled: false },
      ],
      address: [
        {
          id: 'addressLine1',
          type: 'text',
          label: 'Address Line 1',
          disabled: false,
        },
        { id: 'city', type: 'text', label: 'City', disabled: false },
        {
          id: 'addressLine2',
          type: 'text',
          label: 'Address Line 2',
          disabled: false,
        },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip Code', disabled: false },
        {
          id: 'timezone',
          type: 'select',
          label: 'Timezone',
          defaultValue: TimeZones[65],
          options: TimeZones,
        },
      ],
      registration: [
        {
          id: 'createdAt',
          disabled: true,
          type: 'text',
          label: 'Registered At',
        },
        { id: 'clinicId', type: 'text', label: 'ID', disabled: false },
      ],
      clinicDetails: [
        { id: 'npiNumber', type: 'text', label: 'NPI', disabled: false },
        {
          id: 'stateIdNumber',
          type: 'text',
          label: 'State ID',
          disabled: false,
        },
        {
          id: 'taxIdNumber',
          type: 'text',
          label: 'Tax ID EIN',
          disabled: false,
        },
        {
          id: 'taxonomyNumber',
          type: 'text',
          label: 'Taxonomy Number',
          disabled: false,
        },
        {
          id: 'medicalIdTpiNumber',
          type: 'text',
          label: 'Medicaid TPI',
          disabled: false,
        },
        {
          id: 'medicareNumber',
          type: 'text',
          label: 'Medicare Number',
          disabled: false,
        },
        {
          id: 'ots',
          type: 'select',
          label: 'OTS',
          disabled: false,
          options: [
            { id: true, label: 'True', value: true },
            { id: false, label: 'False', value: false },
          ],
        },
        {
          id: 'otsStartDate',
          type: 'date',
          label: 'OTS Start Date',
          disabled: false,
        },
        {
          id: 'autoGeneratedClaimDrop',
          type: 'select',
          label: 'Auto-generated Claim Drop',
          disabled: false,
          options: [
            { id: true, label: 'True', value: true },
            { id: false, label: 'False', value: false },
          ],
        },
        {
          id: 'officeHours',
          type: 'text',
          label: 'Office Hours',
          disabled: false,
        },
        {
          id: 'finId',
          type: 'text',
          label: 'FIN ID',
          disabled: false,
        },
        {
          id: 'revenueChannels',
          type: 'multiselect',
          label: 'Revenue Channels',
          disabled: false,
          options: clinicRevenueChannelOptions,
        },
        {
          id: 'providerServiceType',
          type: 'multiselect',
          label: 'Provider Service Type',
          disabled: false,
          options: clinicProviderServiceTypeOptions,
        },
        {
          id: 'serviceDeliveryModel',
          type: 'select',
          label: 'Service Delivery Model',
          disabled: false,
          options: clinicServiceDeliveryModel,
        },
        {
          id: 'serviceDeliveryThresholds',
          type: 'select',
          label: 'Service Delivery Thresholds',
          disabled: false,
          options: clinicServiceDeliveryThresholds,
        },
        {
          id: 'referralTypes',
          type: 'multiselect',
          label: 'Referral Type',
          disabled: false,
          options: clinicReferralTypes,
        },
      ],
      runBook: [
        {
          id: 'criticalBusinessHours',
          type: 'text',
          label: 'Critical Escalations Instructions At Business Hours',
          disabled: false,
        },
        {
          id: 'criticalAfterHours',
          type: 'text',
          label: 'Critical Escalations Instructions After Hours',
          disabled: false,
        },
        {
          id: 'businessHours',
          type: 'text',
          label: 'Business Hours',
          disabled: false,
        },
        {
          id: 'afterHours',
          type: 'text',
          label: 'After Hours',
          disabled: false,
        },
        {
          id: 'contactMethod',
          type: 'select',
          label: 'Contact Method',
          options: [
            { id: 'Email', label: 'Email' },
            { id: 'Phone', label: 'Phone' },
            { id: 'SMS', label: 'SMS' },
          ],
          disabled: false,
        },
        {
          id: 'contactMethodValue',
          type: 'text',
          label: 'Contact Method Value',
          disabled: false,
        },
        {
          id: 'notes',
          type: 'text',
          label: 'Note',
          disabled: false,
        },
        {
          id: 'dateNoteLogged',
          type: 'date',
          label: 'Date Note',
          disabled: false,
        },
      ],
    },
    clinicThreshold: {
      systolic: [
        {
          id: 'maxCriticalSystolic',
          label: 'Max Critical',
          type: 'text',
        },
        {
          id: 'minCriticalSystolic',
          label: 'Min Critical',
          type: 'text',
        },
        {
          id: 'maxRiskSystolic',
          label: 'Max at risk',
          type: 'text',
        },
        {
          id: 'minRiskSystolic',
          label: 'Min At Risk',
          type: 'text',
        },
      ],
      diastolic: [
        {
          id: 'maxCriticalDiastolic',
          label: 'Max Critical',
          type: 'text',
        },
        {
          id: 'minCriticalDiastolic',
          label: 'Min Critical',
          type: 'text',
        },
        {
          id: 'maxRiskDiastolic',
          label: 'Max at risk',
          type: 'text',
        },
        {
          id: 'minRiskDiastolic',
          label: 'Min At Risk',
          type: 'text',
        },
      ],
      pulse: [
        {
          id: 'maxCriticalPulse',
          label: 'Max Critical',
          type: 'text',
        },
        {
          id: 'minCriticalPulse',
          label: 'Min Critical',
          type: 'text',
        },
        { id: 'maxRiskPulse', label: 'Max at risk', type: 'text' },
        { id: 'minRiskPulse', label: 'Min At Risk', type: 'text' },
      ],
      sleepPulse: [
        {
          id: 'maxCriticalSleepPulse',
          label: 'Max Critical',
          type: 'text',
        },
        {
          id: 'minCriticalSleepPulse',
          label: 'Min Critical',
          type: 'text',
        },
        { id: 'maxRiskSleepPulse', label: 'Max at risk', type: 'text' },
        { id: 'minRiskSleepPulse', label: 'Min At Risk', type: 'text' },
      ],
      glucose: [
        {
          id: 'maxCriticalGlucose',
          label: 'Max Critical',
          type: 'text',
        },
        {
          id: 'minCriticalGlucose',
          label: 'Min Critical',
          type: 'text',
        },
        {
          id: 'maxRiskGlucose',
          label: 'Max at risk',
          type: 'text',
        },
        {
          id: 'minRiskGlucose',
          label: 'Min At Risk',
          type: 'text',
        },
      ],
      sp02: [
        {
          id: 'criticalBloodoxygen',
          label: 'Min Critical',
          type: 'text',
        },
        { id: 'riskBloodoxygen', label: 'Min At risk', type: 'text' },
      ],
      weight: [
        {
          id: 'maxCriticalWeight',
          label: 'Max Critical +/-lbs',
          type: 'text',
        },
        {
          id: 'minCriticalWeight',
          label: 'Min Critical +/-lbs',
          type: 'text',
        },
        {
          id: 'maxRiskWeight',
          label: 'Max at risk +/-lbs',
          type: 'text',
        },
        {
          id: 'minRiskWeight',
          label: 'Min Risk +/-lbs',
          type: 'text',
        },
      ],
      pef: [
        {
          id: 'minCriticalPef',
          label: 'Min Critical (L/min)',
          type: 'text',
        },
        {
          id: 'minRiskPef',
          label: 'Min At Risk (L/min)',
          type: 'text',
        },
      ],
      fev1: [
        {
          id: 'minCriticalFev1',
          label: 'Min Critical (L)',
          type: 'text',
        },
      ],
    },
    clinicAdd: {
      contact: [
        {
          id: 'legalname',
          type: 'text',
          label: 'Legal Name',
          disabled: false,
        },
        {
          id: 'email',
          type: 'text',
          label: 'Business Email',
          disabled: false,
        },
        {
          id: 'phone',
          type: 'text',
          label: 'Business Phone',
          disabled: false,
        },
        { id: 'fax', type: 'text', label: 'Business Fax', disabled: false },
        {
          id: 'callerId',
          type: 'text',
          label: 'Clinic CallerID',
          disabled: false,
        },
      ],
      address: [
        {
          id: 'addressLine1',
          type: 'text',
          label: 'Address Line 1',
          disabled: false,
        },
        { id: 'city', type: 'text', label: 'City', disabled: false },
        {
          id: 'addressLine2',
          type: 'text',
          label: 'Address Line 2',
          disabled: false,
        },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip Code', disabled: false },
      ],
      registration: [
        { id: 'clinicId', type: 'text', label: 'ID', disabled: false },
      ],
      clinicDetails: [
        { id: 'npiNumber', type: 'text', label: 'NPI', disabled: false },
        {
          id: 'stateIdNumber',
          type: 'text',
          label: 'State ID',
          disabled: false,
        },
        {
          id: 'taxIdNumber',
          type: 'text',
          label: 'Tax ID EIN',
          disabled: false,
        },
        {
          id: 'taxonomyNumber',
          type: 'text',
          label: 'Taxonomy Number',
          disabled: false,
        },
        {
          id: 'medicalIdTpiNumber',
          type: 'text',
          label: 'Medicaid TPI',
          disabled: false,
        },
        {
          id: 'medicareNumber',
          type: 'text',
          label: 'Medicare Number',
          disabled: false,
        },
        {
          id: 'ots',
          type: 'select',
          label: 'OTS',
          disabled: false,
          options: [
            { id: true, label: 'True' },
            { id: false, label: 'False' },
          ],
        },
        {
          id: 'otsStartDate',
          type: 'date',
          label: 'OTS Start Date',
          disabled: false,
        },
        {
          id: 'autoGeneratedClaimDrop',
          type: 'select',
          label: 'Auto-generated Claim Drop',
          disabled: false,
          options: [
            { id: 'true', label: 'True' },
            { id: 'false', label: 'False' },
          ],
        },
        {
          id: 'officeHours',
          type: 'text',
          label: 'Office Hours',
          disabled: false,
        },
        {
          id: 'finId',
          type: 'text',
          label: 'FIN ID',
          disabled: false,
        },
        {
          id: 'revenueChannels',
          type: 'multiselect',
          label: 'Revenue Channels',
          disabled: false,
          options: clinicRevenueChannelOptions,
        },
        {
          id: 'providerServiceType',
          type: 'multiselect',
          label: 'Provider Service Type',
          disabled: false,
          options: clinicProviderServiceTypeOptions,
        },
        {
          id: 'serviceDeliveryModel',
          type: 'select',
          label: 'Service Delivery Model',
          disabled: false,
          options: clinicServiceDeliveryModel,
        },
        {
          id: 'serviceDeliveryThresholds',
          type: 'select',
          label: 'Service Delivery Thresholds',
          disabled: false,
          options: clinicServiceDeliveryThresholds,
        },
        {
          id: 'referralTypes',
          type: 'multiselect',
          label: 'Referral Type',
          disabled: false,
          options: clinicReferralTypes,
        },
      ],
    },
  },
  adminPanelsAgency: {
    agencyEdit: {
      contact: [
        { id: 'legalname', type: 'text', label: 'Legal Name', disabled: false },
        { id: 'phone', type: 'text', label: 'Business Phone', disabled: false },
        { id: 'email', type: 'text', label: 'Business Email', disabled: false },
        { id: 'fax', type: 'text', label: 'Business Fax', disabled: false },
      ],
      address: [
        {
          id: 'addressLine1',
          type: 'text',
          label: 'Address Line 1',
          disabled: false,
        },
        { id: 'city', type: 'text', label: 'City', disabled: false },
        {
          id: 'addressLine2',
          type: 'text',
          label: 'Address Line 2',
          disabled: false,
        },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip Code', disabled: false },
      ],
      registration: [
        { id: 'agencyId', type: 'text', label: 'ID', disabled: false },
      ],
      irs: [
        { id: 'npiNumber', type: 'text', label: 'NPI', disabled: false },
        {
          id: 'taxonomyNumber',
          type: 'text',
          label: 'Taxonomy Number',
          disabled: false,
        },
        {
          id: 'stateIdNumber',
          type: 'text',
          label: 'State ID',
          disabled: false,
        },
        {
          id: 'medicalIdTpiNumber',
          type: 'text',
          label: 'Medicaid TPI',
          disabled: false,
        },
        {
          id: 'taxIdNumber',
          type: 'text',
          label: 'Tax ID EIN',
          disabled: false,
        },
        {
          id: 'medicareNumber',
          type: 'text',
          label: 'Medicare Number',
          disabled: false,
        },
      ],
    },
    agencyAdd: {
      contact: [
        {
          id: 'legalname',
          type: 'text',
          label: 'Legal Name',
          disabled: false,
        },
        {
          id: 'phone',
          type: 'text',
          label: 'Business Phone',
          disabled: false,
        },
        {
          id: 'email',
          type: 'text',
          label: 'Business Email',
          disabled: false,
        },
        { id: 'fax', type: 'text', label: 'Business Fax', disabled: false },
      ],
      address: [
        {
          id: 'addressLine1',
          type: 'text',
          label: 'Address Line 1',
          disabled: false,
        },
        { id: 'city', type: 'text', label: 'City', disabled: false },
        {
          id: 'addressLine2',
          type: 'text',
          label: 'Address Line 2',
          disabled: false,
        },
        {
          id: 'state',
          type: 'select',
          label: 'State',
          options: usStatesWithNone,
          disabled: false,
        },
        { id: 'zip', type: 'text', label: 'Zip Code', disabled: false },
      ],
      registration: [
        { id: 'agencyId', type: 'text', label: 'ID', disabled: false },
      ],
      irs: [
        { id: 'npiNumber', type: 'text', label: 'NPI', disabled: false },
        {
          id: 'taxonomyNumber',
          type: 'text',
          label: 'Taxonomy Number',
          disabled: false,
        },
        {
          id: 'stateIdNumber',
          type: 'text',
          label: 'State ID',
          disabled: false,
        },
        {
          id: 'medicalIdTpiNumber',
          type: 'text',
          label: 'Medicaid TPI',
          disabled: false,
        },
        {
          id: 'taxIdNumber',
          type: 'text',
          label: 'Tax ID EIN',
          disabled: false,
        },
        {
          id: 'medicareNumber',
          type: 'text',
          label: 'Medicare Number',
          disabled: false,
        },
      ],
    },
  },
  childClinicSelect: [
    { value: true, label: 'Included' },
    { value: false, label: 'Excluded' },
  ],
};
